// const { default: ReAssignment } = require("@/components/ReAssignment.vue");

module.exports = {
  changeIso: {
    es: "¿Desea cambiar el idioma?",
    en: "Do you want to change the language?",
  },
  pointsRewards: {
    es: "Puntos",
    en: "Rewards",
  },
  points: {
    es: "Puntos",
    en: "Points",
  },
  pointsHistory: {
    es: "Historial de puntos",
    en: "Points history",
  },
  noPointsHistory: {
    es: "Sin historial de puntos",
    en: "No points history",
  },
  assignedBy: {
    es: "Asignado por",
    en: "Assigned by",
  },
  assignedBySystem: {
    es: "Sistema",
    en: "System",
  },
  assignedByRenewal: {
    es: "Renovación",
    en: "Renewal",
  },
  amountPoint: {
    es: "Monto",
    en: "Amount",
  },
  origin: {
    es: "Origen",
    en: "Origin",
  },
  typePoint: {
    es: "Tipo",
    en: "Type",
  },
  addPoints: {
    es: "Agregar puntos",
    en: "Add points",
  },
  addPoints__title: {
    es: "Agregar puntos manuales",
    en: "Add manual points",
  },
  addPointsReason: {
    es: "Motivo",
    en: "Reason",
  },
  addPointsReasonDetail: {
    es: "Detalles del motivo",
    en: "Reason details",
  },
  addPointsReasonRenewal: {
    es: "Incentivo por renovación",
    en: "Renewal incentive",
  },
  addPointsReasonRecovery: {
    es: "Incentivo por recuperación",
    en: "Recovery incentive",
  },
  addPointsReasonOther: {
    es: "Otro",
    en: "Other",
  },
  addPoints__msg1: {
    es: "Puntos agregados con éxito",
    en: "Points added successfully",
  },
  addPoints__msg2: {
    es: "Error al agregar puntos",
    en: "Error adding points",
  },
  addPoints__msg3: {
    es: "El monto es obligatorio",
    en: "Amount is required",
  },
  otpCode: {
    es: "Código OTP",
    en: "OTP Code",
  },
  otpPlaceholder: {
    es: "Ingresa el código de 4 dígitos",
    en: "Enter the 4-digit code",
  },
  otpSent: {
    es: "Se envió un código OTP a tu correo",
    en: "An OTP code was sent to your email",
  },
  otpRequired: {
    es: "El código OTP es obligatorio y debe tener 4 dígitos",
    en: "OTP code is required and must be 4 digits",
  },
  otpSendError: {
    es: "Error al enviar el código OTP",
    en: "Error sending OTP code",
  },
  otpInvalid: {
    es: "Código OTP inválido, intenta de nuevo",
    en: "Invalid OTP code, try again",
  },
  otpResend: {
    es: "Reenviar código",
    en: "Resend code",
  },
  pointsRecipient: {
    es: "Destinatario",
    en: "Recipient",
  },
  noCoOwner: {
    es: "No hay cotitular registrado",
    en: "No co-owner registered",
  },
  noCoOwnerSelected: {
    es: "No hay cotitular al que asignar puntos",
    en: "No co-owner to assign points",
  },
  logout: {
    es: "Cerrar sesión",
    en: "Log out",
  },
  weeks: {
    es: "Semanas",
    en: "Weeks",
  },
  reserves: {
    es: "Reservas",
    en: "Bookings",
  },
  search: {
    es: "Busqueda",
    en: "Search",
  },
  financing: {
    es: "Financiamiento",
    en: "Financing",
  },
  paymentsContract: {
    es: "Pagos por contrato",
    en: "Contract payments",
  },
  resetSearch: {
    es: "Restablecer Busqueda",
    en: "Reset Search",
  },
  invetoryType: {
    es: "Tipo de Inventario",
    en: "Inventory Type",
  },
  all: {
    es: "Todos",
    en: "All",
  },
  country: {
    es: "País",
    en: "Country",
  },
  bestSellers: {
    es: "Más Vendidos",
    en: "Best Sellers",
  },
  state: {
    es: "Estado",
    en: "State",
  },

  city: {
    es: "Ciudad",
    en: "City",
  },
  filters: {
    es: "Filtros",
    en: "Filters",
  },
  quantity: {
    es: "Cantidad",
    en: "Quantity",
  },
  copyXml: {
    es: "Copiar XML",
    en: "Copy XML",
  },
  spanish: {
    es: "Español",
    en: "Spanish",
  },
  english: {
    es: "Ingles",
    en: "English",
  },
  addPayExternal: {
    es: "Agregar Pago Externo",
    en: "Add External Payment",
  },
  add: {
    es: "Agregar",
    en: "Add",
  },
  cancel: {
    es: "Cancelar",
    en: "Cancel",
  },
  typePayment: {
    es: "Tipo de Pago",
    en: "Payment Type",
  },
  idTransaction: {
    es: "ID Transacción",
    en: "Transaction ID",
  },
  amount: {
    es: "Monto",
    en: "Amount",
  },
  findByResort: {
    es: "Buscar por resort",
    en: "Search by resort",
  },
  cardHolder: {
    es: "Titular de la tarjeta",
    en: "Cardholder",
  },
  emailAgent: {
    es: "Correo del agente",
    en: "Agent's email",
  },

  noResultsFound: {
    es: "No se encontro resultados",
    en: "No results found",
  },
  hide: {
    es: "Ocultar",
    en: "Hide",
  },
  open: {
    es: "Abrir",
    en: "Open",
  },
  refreshCache: {
    es: "Actualizar caché",
    en: "Refresh cache",
  },
  newVersionAvailable: {
    es: "Hay una nueva versión disponible",
    en: "A new version is available",
  },
  updatingVersion: {
    es: "Actualizando a la nueva versión...",
    en: "Updating to the new version...",
  },
  reload: {
    es: "Recargar",
    en: "Reload",
  },
  amenities: {
    es: "Amenidades",
    en: "Amenities",
  },
  acceptUpdateTraveler: {
    es: "¿Desea continuar con la actualización?",
    en: "Do you want to continue with the update?",
  },
  yes: {
    es: "Si",
    en: "Yes",
  },
  sendConfirmation: {
    es: "Enviar Confirmación",
    en: "Send Confirmation",
  },
  client: {
    es: "Cliente",
    en: "Client",
  },
  addAEmail: {
    es: "Agrega un email",
    en: "Add an email",
  },
  onlySendToCopies: {
    es: "Solo enviar a copias",
    en: "Only send to copies",
  },
  send: {
    es: "Enviar",
    en: "Send",
  },
  blockedByPermissions: {
    es: "Bloqueado por permisos",
    en: "Blocked by permissions",
  },
  name: {
    es: "Nombre",
    en: "Name",
  },
  fullname: {
    es: "Nombre Completo",
    en: "Full Name",
  },
  lastname: {
    es: "Apellido",
    en: "Last name",
  },
  lastname_ext: {
    es: "Apellido Paterno",
    en: "Last name",
  },
  mothersLastname: {
    es: "Apellido Materno",
    en: "Mother's last name",
  },
  email: {
    es: "Correo Electrónico",
    en: "Email",
  },
  birthdate: {
    es: "Fecha de nacimiento",
    en: "Birthdate",
  },
  codCellphone: {
    es: "Código Celular",
    en: "Cellphone Code",
  },
  cellphone: {
    es: "Celular",
    en: "Cellphone",
  },
  codPhone: {
    es: "Código Teléfono",
    en: "Phone Code",
  },
  phone: {
    es: "Teléfono",
    en: "Phone",
  },
  address: {
    es: "Dirección",
    en: "Address",
  },
  ipAddress: {
    es: "Dirección IP",
    en: "IP Address",
  },
  zip: {
    es: "Código Postal",
    en: "Zip",
  },
  contract: {
    es: "Contrato",
    en: "Contract",
  },
  language: {
    es: "Idioma",
    en: "Language",
  },
  settings: {
    es: "Ajustes",
    en: "Settings",
  },
  payments: {
    es: "Pagos",
    en: "Payments",
  },
  catcher: {
    es: "Capturador",
    en: "Capturer",
  },
  renewals: {
    es: "Renovaciones",
    en: "Renewals",
  },
  renewal: {
    es: "Renovacion",
    en: "Renewal",
  },
  online: {
    es: "Online",
    en: "Online",
  },
  statistics: {
    es: "Estadísticas",
    en: "Statistics",
  },
  advancedSearch: {
    es: "Busqueda Avanzada",
    en: "Advanced Search",
  },
  followUpRenewals: {
    es: "Seguimiento",
    en: "Follow-up",
  },
  customerPortfolio: {
    es: "Cartera de Clientes",
    en: "Customer Portfolio",
  },
  members: {
    es: "Socios",
    en: "Members",
  },
  creationDate: {
    es: "Fecha de Creación",
    en: "Creation Date",
  },
  expiredAt: {
    es: "Fecha de expiración",
    en: "Expiration date",
  },
  edit: {
    es: "Editar",
    en: "Edit",
  },
  comments: {
    es: "Comentarios",
    en: "Comments",
  },
  messageValidateSearch: {
    es: "No esta permitido caracteres especiales ni espacios en blanco",
    en: "Not allowed special characters or blank spaces",
  },
  editMember: {
    es: "Editar socio",
    en: "Edit member",
  },
  codCountry: {
    es: "Código de País",
    en: "Country code",
  },
  createdBy: {
    es: "Creado por",
    en: "Created By",
  },
  resetPassword: {
    es: "Restablecer contraseña",
    en: "Restore password",
  },
  resetPassword__confirm: {
    es: "Se le enviará un correo al usuario con la nueva contraseña",
    en: "An email will be sent to the user with the new password",
  },
  resetPassword__confirm__success: {
    es: "Contraseña enviada",
    en: "Password sent",
  },
  accept: {
    es: "Aceptar",
    en: "Accept",
  },
  addComment: {
    es: "Agrega un comentario",
    en: "Add a comment",
  },
  noComment: {
    es: "Sin comentarios",
    en: "No comment",
  },
  settingsPayments: {
    es: "Configuración de pagos",
    en: "Payments settings",
  },
  createNewPayment: {
    es: "Crear método de pago",
    en: "Create payment method",
  },
  paymentMethod: {
    es: "Método de pago",
    en: "Payment method",
  },
  stripePaymentIntentID: {
    es: "ID de Intento de Pago de Stripe",
    en: "Stripe Payment Intent ID",
  },
  stripeChangeID: {
    es: "ID de Cambio de Stripe",
    en: "Stripe Charge ID",
  },
  save: {
    es: "Guardar",
    en: "Save",
  },
  code: {
    es: "Código",
    en: "Code",
  },
  description: {
    es: "Descripción",
    en: "Description",
  },
  publicToken: {
    es: "Token publico",
    en: "Public token",
  },
  test: {
    es: "Prueba",
    en: "Test",
  },
  privateToken: {
    es: "Token privado",
    en: "Private token",
  },
  currency: {
    es: "Divisa",
    en: "Currency",
  },
  main: {
    es: "Principal",
    en: "Main",
  },
  status: {
    es: "Estado",
    en: "Status",
  },
  statuss: {
    es: "Estados",
    en: "Status",
  },
  deletePaymentMethod: {
    es: "Eliminar método de pago",
    en: "Remove payment method",
  },
  addMainPaymentMethod: {
    es: "Establecer como principal",
    en: "Set as main",
  },
  textDeletePaymentMethod: {
    es: "Al eliminar este método de pago los enlaces de pagos que ya fueron generados con esta cuenta se mantendrán activas.",
    en: "By eliminating this payment method, payment links that were already generated with this account will remain active.",
  },
  textSetPaymentMethod: {
    es: "Al cambiar el método de pago predeterminado, los enlaces de pagos que ya fueron generados no cambiaran de cuenta.",
    en: "When changing the default payment method, the payment links that were already generated will not change their account.",
  },
  doYouWishToContinue: {
    es: "¿Desea Continuar?",
    en: "Do you wish to continue?",
  },
  fastSearch: {
    es: "Búsqueda Rápida",
    en: "Fast Search",
  },
  registrationDate: {
    es: "Fecha de Registro",
    en: "Registration Date",
  },
  processingDate: {
    es: "Fecha de Procesamiento",
    en: "Processing Date",
  },
  renewalDate: {
    es: "Fecha de Renovación",
    en: "Renewal Date",
  },
  membershipStatus: {
    es: "Estado de la Membresía",
    en: "Membership Status",
  },
  contractStatus: {
    es: "Estado del Contrato",
    en: "Contract Status",
  },
  current: {
    es: "Vigente",
    en: "Current",
  },
  bookings: {
    es: "Reservaciones",
    en: "Bookings",
  },
  // Tipos de viaje de Travel Compositor (booking.tripType)
  bookingTripTypes: {
    ONLY_HOTEL: { es: "Hotel", en: "Hotel" },
    ONLY_CRUISE: { es: "Crucero", en: "Cruise" },
    WEEK: { es: "Semana", en: "Week" },
    ONLY_FLIGHT: { es: "Vuelo", en: "Flight" },
    FLIGHT_HOTEL: { es: "Vuelo + Hotel", en: "Flight + Hotel" },
    ONLY_CAR: { es: "Vehículo", en: "Vehicle" },
    ONLY_TRANSFER: { es: "Traslado", en: "Transfer" },
    ONLY_TICKET: { es: "Boleto", en: "Ticket" },
    MULTI: { es: "Multi", en: "Multi" },
    MAGIC_BOX: { es: "Magic Box", en: "Magic Box" },
  },
  expired: {
    es: "Expirado",
    en: "Expired",
  },
  viewProfile: {
    es: "Ver Perfil",
    en: "View Profile",
  },
  memberProfile: {
    es: "Perfil Socio",
    en: "Member Profile",
  },
  details: {
    es: "Detalles",
    en: "Details",
  },
  accountStatus: {
    es: "Estado de Cuenta",
    en: "Account Status",
  },
  renovations: {
    es: "Renovaciones",
    en: "Renewals",
  },
  documents: {
    es: "Documentos",
    en: "Documents",
  },
  sendAllSignatures: {
    es: "Enviar todas las firmas",
    en: "Send all signatures",
  },
  sendAllSignaturesConfirm: {
    es: "¿Desea enviar todas las firmas?",
    en: "Do you want to send all signatures?",
  },
  sendAllSignaturesSuccess: {
    es: "Firmas enviadas con éxito",
    en: "Signatures sent successfully",
  },
  sendAllSignaturesError: {
    es: "Ocurrió un error al enviar las firmas",
    en: "An error occurred while sending signatures",
  },
  memberType: {
    es: "Tipo de Socio",
    en: "Member Type",
  },
  onlyHeadlines: {
    es: "Solo titulares",
    en: "Only Headlines",
  },
  owner: {
    es: "Titular",
    en: "Owner",
  },
  coOwner: {
    es: "Co-Titular",
    en: "Co-Owner",
  },
  viewContract: {
    es: "Ver Contrato",
    en: "View Contract",
  },
  contractNumber: {
    es: "Número de Contrato",
    en: "Contract number",
  },
  years: {
    es: "Años",
    en: "Years",
  },
  LoginID: {
    es: "LoginID",
    en: "LoginID",
  },
  processableDate: {
    es: "Fecha de Procesamiento",
    en: "Process Date",
  },
  fee: {
    es: "Tarifa",
    en: "Fee",
  },
  period: {
    es: "Periodo",
    en: "Billing",
  },
  nextInvoice: {
    es: "Periodo Anual - Proxima Factura en",
    en: "Billing Annual - Next Invoice on",
  },
  for: {
    es: "de",
    en: "for ",
  },
  periodRenew: {
    es: "Periodo Renovación",
    en: "Renewal Period",
  },
  startEndPeriod: {
    es: "Inicio - Fin Periodo",
    en: "Start - End Period",
  },
  purchaseDate: {
    es: "Fecha de Compra",
    en: "Purchase Date",
  },
  annuaPlan: {
    es: "Plan Anual",
    en: "Annual Plan",
  },
  renovationDate: {
    es: "Fecha de Renovación",
    en: "Renovation Date",
  },
  activationDate: {
    es: "Fecha de Activación",
    en: "Activation Date",
  },
  cancellationDate: {
    es: "Fecha de Cancelación",
    en: "Cancellation date",
  },
  emitDate: {
    es: "Fecha de emisión",
    en: "Emit date",
  },
  number: {
    es: "Numero",
    en: "Number",
  },
  nroContract: {
    es: "Numero de contrato",
    en: "Contract number",
  },
  rci: {
    es: "RCI",
    en: "RCI",
  },
  fingerprint: {
    es: "Huella digital",
    en: "Fingerprint",
  },
  showMoreResults: {
    es: "Mostrar más resultados",
    en: "Show more results",
  },
  noMoreResults: {
    es: "No hay más resultados",
    en: "There are no more results",
  },
  findLoginId: {
    es: "Buscar socios por LoginID",
    en: "Search members by LoginID",
  },
  nationality: {
    es: "Nacionalidad",
    en: "Nationality",
  },
  civilStatus: {
    es: "Estado Civil",
    en: "Marital Status",
  },
  charge: {
    es: "Cargo",
    en: "Charge",
  },
  payDay: {
    es: "Fecha de Pago",
    en: "Payment Day",
  },
  renewalAssign: {
    es: "Asignar a agente",
    en: "Assign to agent",
  },
  dateStartPeriod: {
    es: "Fecha Inicio Periodo",
    en: "Date start period",
  },
  dateEndPeriod: {
    es: "Fecha Fin Periodo",
    en: "Date end period",
  },
  periods: {
    es: "Periodos",
    en: "Periods",
  },
  payConfirm: {
    es: "Referencia de Pago",
    en: "Payment Reference",
  },
  onlineRenewals: {
    es: "Renovaciones en línea",
    en: "Online renewals",
  },
  broadcastDate: {
    es: "Fecha de Emisión",
    en: "Start date",
  },
  paid: {
    es: "Pagado",
    en: "Paid",
  },
  paidDate: {
    es: "Fecha de Pago",
    en: "Payment Date",
  },
  topic: {
    es: "Asunto",
    en: "Subject",
  },
  validateMsgTopic: {
    es: "Selecciona un tema para enviar el comentario",
    en: "Select a topic to send the comment",
  },
  sendLink: {
    es: "Enviar enlace",
    en: "Send link",
  },
  languageUser: {
    es: "Idioma del Socio",
    en: "Language of the Member",
  },
  pending: {
    es: "Pendiente",
    en: "Pending",
  },
  registered: {
    es: "Registrado",
    en: "Registered",
  },
  pendingToSign: {
    es: "Pendiente de Firma",
    en: "Pending to Sign",
  },
  pendingToPay: {
    es: "Pendiente de Pago",
    en: "Pending to Pay",
  },
  won: {
    es: "Ganado",
    en: "Won",
  },
  lost: {
    es: "Perdido",
    en: "Lost",
  },
  procesable: {
    es: "Procesable",
    en: "Processable",
  },
  cancelled: {
    es: "Cancelado",
    en: "Canceled",
  },
  beneficiaries: {
    es: "Friends and Family",
    en: "Friends and Family",
  },
  exportToCsv: {
    es: "Exportar CSV",
    en: "Export CSV",
  },
  goBack: {
    es: "Volver",
    en: "Go Back",
  },
  renew: {
    es: "Link de Pago",
    en: "Payment Link",
  },
  addPayment: {
    es: "Agregar Pago",
    en: "Add Payment",
  },
  renew__message1: {
    es: "Introduzca la cantidad de años",
    en: "Enter the number of years",
  },
  renew__message2: {
    es: "Introduzca el código de descuento (Opcional)",
    en: "Enter the discount code (Optional)",
  },
  renew__message3: {
    es: "Introduzca el ID del contrato",
    en: "Enter the Contract ID",
  },
  next: {
    es: "Siguiente",
    en: "Next",
  },
  paymentsLinks: {
    es: "Enlaces de Pago",
    en: "Payments Links",
  },
  paymentLink: {
    es: "Enlace de Pago",
    en: "Payment Link",
  },
  createPaymentsLinks: {
    es: "Crear enlaces de pago",
    en: "Create payment links",
  },
  reservation: {
    es: "Reservacion",
    en: "Reservation",
  },
  createPaymentsLinks__msgOk: {
    es: "Enlace de pago creado con éxito",
    en: "Payment link created successfully",
  },
  createPaymentsLinks__msg1: {
    es: "Ingresa la referencia de la reservación",
    en: "Enter the reservation reference",
  },
  createPaymentsLinks__msg2: {
    es: "Ingresa el correo electrónico",
    en: "Enter email",
  },
  changeStatusMembership: {
    es: "Cambiar estado de la membresía",
    en: "Change a membership status",
  },
  changeStatusContract: {
    es: "Cambiar estado del contrato",
    en: "Change contract status",
  },
  active: {
    es: "Activo",
    en: "Active",
  },
  inactive: {
    es: "Inactivo",
    en: "Inactive",
  },
  actions: {
    es: "Acciones",
    en: "Actions",
  },
  linkCopy__msg1: {
    es: "Enlace copiado con éxito",
    en: "Link copied successfully",
  },
  linkCopy__msg2: {
    es: "Enlace enviado con éxito",
    en: "Link sent successfully",
  },
  system: {
    es: "Sistema",
    en: "System",
  },
  users: {
    es: "Usuarios",
    en: "Users",
  },
  user: {
    es: "Usuario",
    en: "User",
  },
  roles: {
    es: "Roles",
    en: "Roles",
  },
  clubs: {
    es: "Clubes",
    en: "Clubs",
  },
  activations: {
    es: "Activaciones",
    en: "Activations",
  },
  tutorialsMeetings: {
    es: "Tutoriales / Reuniones",
    en: "Tutorials / Meetings",
  },
  qrCobro: {
    es: "Cobro QR",
    en: "QR Payments",
  },
  qrMisClientes: {
    es: "Mis clientes",
    en: "My customers",
  },
  qrVentas: {
    es: "Ventas QR",
    en: "QR Sales",
  },
  qrPromotores: {
    es: "Promotores",
    en: "Promoters",
  },
  qrCampanas: {
    es: "Campañas",
    en: "Campaigns",
  },
  tutoringFollowUp: {
    es: {
      title: "Seguimiento de Tutorías",
      subtitle:
        "Reunión agendada, Tutoría registrada y deal asociado: las tres piezas que deben quedar completas en cada tutorial.",
      summaryTitle: "Resumen",
      lastDays: "Últimos {n} días",
      refresh: "Actualizar",
      meetings: "Reuniones",
      toOccur: "Por ocurrir",
      occurred: "Ocurridas",
      attended: "Asistieron",
      noShow: "No show",
      complete: "Completos",
      withoutTutoring: "Sin tutoría",
      aboutToExpire: "Por vencer",
      expired: "Perdidos",
      withoutDeal: "Sin deal",
      withRecording: "Con grabación",
      meetingsHint: "Agendadas en el periodo",
      toOccurHint: "Todavía no ocurren",
      attendedHint: "De las reuniones ocurridas",
      completeHint: "Reunión, tutoría y deal listos",
      withoutTutoringHint: "Falta registrar la Tutoría",
      aboutToExpireHint: "Todavía se pueden registrar: hay que ir a buscarlos",
      expiredHint: "Pasaron los 7 días, ya no hay nada que hacer",
      withoutDealHint: "Registrada pero sin deal asociado",
      withRecordingHint: "Con link de grabación disponible",
      bySituation: "Por situación:",
      situationFilterHint: "Da click en una situación para filtrar la tabla",
      clearSituations: "Quitar filtro de situación",
      results: "{n} filas",
      pageOf: "página {p} de {t}",
      pendingByAgent: "Pendientes por agente",
      noPendingAgents: "Sin pendientes por agente",
      searchLogin: "Buscar por LoginID",
      loginPlaceholder: "LoginID del socio",
      search: "Buscar",
      clear: "Limpiar",
      showingAllFor: "Mostrando todas las reuniones de",
      status: "Estado",
      club: "Club",
      agent: "Agente",
      allClubs: "Todos los clubes",
      allAgents: "Todos los agentes",
      pageSize: "Por página",
      colLoginId: "LoginID",
      colMember: "Socio",
      colClub: "Club",
      colMeeting: "Reunión",
      colAgent: "Agente",
      colDuration: "Duración",
      colSituation: "Situación",
      colDeadline: "Plazo para registrar",
      colRecording: "Grabación",
      noMeeting: "Sin reunión agendada",
      guest: "Invitado",
      noLoginId: "Sin LoginID",
      minutes: "min",
      pendingCalc: "Pendiente de cálculo",
      noData: "—",
      viewRecording: "Ver grabación",
      noConsent: "Sin consentimiento",
      noRecording: "Sin grabación",
      daysShort: "d",
      outOfTime: "Fuera de plazo",
      registeredLate: "Registrada tarde",
      deadlineHelpDays:
        "Quedan {n} días para registrar la Tutoría. Al cumplirse los 7 días el sistema deja de buscar la duración y la grabación de esta sesión.",
      deadlineHelpLost:
        "Se cumplieron los 7 días sin registrar la Tutoría: la sesión perdió su duración y su grabación",
      deadlineHelpDone: "Tutoría registrada, no hay plazo pendiente",
      deadlineHelpLate:
        "La Tutoría se registró después de los 7 días del plazo",
      deadlineHelpNone: "Esta fila no tiene plazo que correr",
      legendSituation: "en qué quedó el tutorial",
      legendDeadline:
        "días que quedan para que el agente registre la Tutoría; al día 7 se pierden duración y grabación",
      empty: "No hay reuniones que coincidan con los filtros",
      detailMeeting: "Reunión",
      detailTutoring: "Tutoría",
      detailDeal: "Deal",
      detailRecording: "Grabación",
      detailMissing: "Faltantes",
      nothingMissing: "Nada pendiente",
      contract: "Contrato",
      meetingTitle: "Título",
      timezone: "Zona horaria",
      meetingStatus: "Estado de la reunión",
      occurredLabel: "Ocurrió",
      attendedLabel: "Asistió",
      engagement: "Engagement",
      registered: "Registrada",
      notRegistered: "No registrada",
      result: "Resultado",
      sessionDate: "Fecha de sesión",
      createdBy: "Registrada por",
      associated: "Asociado",
      notAssociated: "Sin asociar",
      consent: "Consentimiento",
      recordingState: "Estado",
      yes: "Sí",
      no: "No",
      copied: "LoginID copiado",
      errorSummary: "Error al consultar el resumen de tutorías",
      errorRows: "Error al consultar el seguimiento de tutorías",
      errorClubs: "Error al consultar datos de clubes",
      situations: {
        agendada: "Agendada",
        no_show: "No show",
        sin_calcular: "Sin calcular",
        falta_registrar: "Falta registrar",
        vencida: "Perdida",
        falta_deal: "Falta deal",
        completa: "Completa",
        sin_reunion: "Sin reunión",
      },
      situationsHelp: {
        agendada: "La reunión todavía no ocurre",
        no_show: "El socio no llegó a la reunión",
        sin_calcular: "Ocurrió, falta que el cron calcule la duración",
        falta_registrar:
          "El agente debe registrar la Tutoría, aún está a tiempo",
        vencida:
          "Pasaron los 7 días sin registrar la Tutoría: la sesión perdió para siempre su duración y su grabación",
        falta_deal: "Tutoría registrada pero sin deal asociado al contrato",
        completa: "Reunión, Tutoría y deal listos",
        sin_reunion: "El contrato no tiene ninguna reunión agendada",
      },
      states: {
        todos: "Todos",
        completos: "Completos",
        incompletos: "Incompletos",
        sin_tutoria: "Sin tutoría",
        vencidos: "Perdidos (fuera de plazo)",
        por_vencer: "Por vencer (urgentes)",
      },
    },
    en: {
      title: "Tutoring Follow-up",
      subtitle:
        "Scheduled meeting, registered Tutoring and associated deal: the three pieces that must be completed for every tutorial.",
      summaryTitle: "Summary",
      lastDays: "Last {n} days",
      refresh: "Refresh",
      meetings: "Meetings",
      toOccur: "Upcoming",
      occurred: "Occurred",
      attended: "Attended",
      noShow: "No show",
      complete: "Complete",
      withoutTutoring: "No tutoring",
      aboutToExpire: "About to expire",
      expired: "Lost",
      withoutDeal: "No deal",
      withRecording: "With recording",
      meetingsHint: "Scheduled in the period",
      toOccurHint: "Have not happened yet",
      attendedHint: "Out of the meetings that occurred",
      completeHint: "Meeting, tutoring and deal ready",
      withoutTutoringHint: "The Tutoring is still not registered",
      aboutToExpireHint: "Still registrable: these need to be chased now",
      expiredHint: "The 7 days are gone, there is nothing left to do",
      withoutDealHint: "Registered but with no associated deal",
      withRecordingHint: "With an available recording link",
      bySituation: "By situation:",
      situationFilterHint: "Click a situation to filter the table",
      clearSituations: "Clear situation filter",
      results: "{n} rows",
      pageOf: "page {p} of {t}",
      pendingByAgent: "Pending by agent",
      noPendingAgents: "No pending items by agent",
      searchLogin: "Search by LoginID",
      loginPlaceholder: "Member LoginID",
      search: "Search",
      clear: "Clear",
      showingAllFor: "Showing every meeting of",
      status: "Status",
      club: "Club",
      agent: "Agent",
      allClubs: "All clubs",
      allAgents: "All agents",
      pageSize: "Per page",
      colLoginId: "LoginID",
      colMember: "Member",
      colClub: "Club",
      colMeeting: "Meeting",
      colAgent: "Agent",
      colDuration: "Duration",
      colSituation: "Situation",
      colDeadline: "Deadline to register",
      colRecording: "Recording",
      noMeeting: "No meeting scheduled",
      guest: "Guest",
      noLoginId: "No LoginID",
      minutes: "min",
      pendingCalc: "Pending calculation",
      noData: "—",
      viewRecording: "View recording",
      noConsent: "No consent",
      noRecording: "No recording",
      daysShort: "d",
      outOfTime: "Out of time",
      registeredLate: "Registered late",
      deadlineHelpDays:
        "{n} days left to register the Tutoring. Once the 7 days are up the system stops looking for this session's duration and recording.",
      deadlineHelpLost:
        "The 7 days passed with no Tutoring registered: the session lost its duration and its recording",
      deadlineHelpDone: "Tutoring registered, no deadline running",
      deadlineHelpLate: "The Tutoring was registered after the 7-day deadline",
      deadlineHelpNone: "This row has no deadline running",
      legendSituation: "how the tutorial ended up",
      legendDeadline:
        "days left for the agent to register the Tutoring; on day 7 duration and recording are lost",
      empty: "There are no meetings matching the filters",
      detailMeeting: "Meeting",
      detailTutoring: "Tutoring",
      detailDeal: "Deal",
      detailRecording: "Recording",
      detailMissing: "Missing",
      nothingMissing: "Nothing pending",
      contract: "Contract",
      meetingTitle: "Title",
      timezone: "Time zone",
      meetingStatus: "Meeting status",
      occurredLabel: "Occurred",
      attendedLabel: "Attended",
      engagement: "Engagement",
      registered: "Registered",
      notRegistered: "Not registered",
      result: "Result",
      sessionDate: "Session date",
      createdBy: "Registered by",
      associated: "Associated",
      notAssociated: "Not associated",
      consent: "Consent",
      recordingState: "Status",
      yes: "Yes",
      no: "No",
      copied: "LoginID copied",
      errorSummary: "Error loading the tutoring summary",
      errorRows: "Error loading the tutoring follow-up",
      errorClubs: "Error loading clubs",
      situations: {
        agendada: "Scheduled",
        no_show: "No show",
        sin_calcular: "Not calculated",
        falta_registrar: "To be registered",
        vencida: "Lost",
        falta_deal: "Deal missing",
        completa: "Complete",
        sin_reunion: "No meeting",
      },
      situationsHelp: {
        agendada: "The meeting has not happened yet",
        no_show: "The member did not show up",
        sin_calcular: "It occurred, the cron still has to compute the duration",
        falta_registrar: "The agent must register the Tutoring, still on time",
        vencida:
          "The 7 days passed with no Tutoring registered: the session lost its duration and its recording for good",
        falta_deal: "Tutoring registered but with no deal on the contract",
        completa: "Meeting, Tutoring and deal are ready",
        sin_reunion: "The contract has no scheduled meeting",
      },
      states: {
        todos: "All",
        completos: "Complete",
        incompletos: "Incomplete",
        sin_tutoria: "No tutoring",
        vencidos: "Lost (out of time)",
        por_vencer: "About to expire (urgent)",
      },
    },
  },
  assignmentActivation: {
    es: "Asignación / Activación",
    en: "Assignment / Activation",
  },
  assignedAgent: {
    es: "Agente Asignado",
    en: "Assigned agent",
  },
  assign: {
    es: "Asignar",
    en: "Assign",
  },
  activate: {
    es: "Activar",
    en: "Activate",
  },
  scheduleTutorial: {
    es: "Agendar tutorial",
    en: "Schedule tutorial",
  },
  actions: {
    es: "Acciones",
    en: "Actions",
  },
  lastLogin: {
    es: "Último Inicio de Sesión",
    en: "Last Login",
  },
  selectAgent: {
    es: "Seleccione un agente",
    en: "Select an agent",
  },
  agent: {
    es: "Agente",
    en: "Agent",
  },
  massiveActivateContracts__msg1: {
    es: "Contratos activos con éxito",
    en: "Successfully active contracts",
  },
  massiveActivateContracts__msg2: {
    es: "¿Deseas activar {{total}} contratos seleccionados?",
    en: "Do you want to activate {{total}} selected contracts?",
  },
  massiveAssignContracts__msg1: {
    es: "Contratos asignados con éxito",
    en: "Successfully assigned contracts",
  },
  massiveAssignContracts__msg2: {
    es: "¿Deseas asignar {{total}} contratos a {{staff}}?",
    en: "Do you want to assign {{total}} contracts to {{staff}}?",
  },
  subscriptionStatus: {
    es: "Estado de la Suscripción",
    en: "Subscription Status",
  },
  subscription: {
    es: "Suscripción",
    en: "Subscription",
  },
  sendEmailMembershipStatus: {
    es: "Enviar correo de bienvenida",
    en: "Send welcome email",
  },
  addTraveler: {
    es: "Agregar Viajero",
    en: "Add Traveler",
  },
  exportToExcel: {
    es: "Exportar a Excel",
    en: "Export to Excel",
  },
  accessDenied: {
    es: "Acceso denegado",
    en: "Access denied",
  },
  notFound404: {
    es: "Pagina no encontrada",
    en: "Page not found",
  },
  notFound404__msg1: {
    es: "Esta pagina no esta disponible o no tiene los permisos necesarios",
    en: "This page is not available or does not have the necessary permissions",
  },
  months: {
    en: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    es: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre",
    ],
  },
  filterStage: {
    es: "Filtrar Etapa",
    en: "Filter Stage",
  },
  membershipType: {
    es: "Tipo de Membresía",
    en: "Membership Type",
  },
  type: {
    es: "Tipo",
    en: "Type",
  },
  unlimited: {
    es: "Ilimitado",
    en: "Unlimited",
  },

  membershipBenefits: {
    es: "Beneficios de la Membresía",
    en: "Membership Benefits",
  },
  vipWeeks: {
    es: "VIP Weeks",
    en: "VIP Weeks",
  },
  smartWeeks: {
    es: "Smart Weeks",
    en: "Smart Weeks",
  },
  lastMinuteWeeks: {
    es: "Last Minute Weeks",
    en: "Last Minute Weeks",
  },
  selectAnOption: {
    es: "Selecciona una opción",
    en: "Select an option",
  },
  relationship: {
    es: "Parentesco",
    en: "Relationship",
  },
  relationship__msg1: {
    es: "Solo se acepta cinco (5) beneficiarios",
    en: "Only five (5) beneficiaries are accepted",
  },
  relationship__msg2: {
    es: "Agregar beneficiario",
    en: "Add beneficiary",
  },
  incentives: {
    es: "Incentivos",
    en: "Incentives",
  },
  incentives__msg1: {
    es: "Solo se acepta cinco (5) Incentivos",
    en: "Only five (5) Incentives are accepted",
  },
  travelVoucher: {
    es: "Travel Voucher",
    en: "Travel Voucher",
  },
  discountTravelVoucher: {
    es: "Descuento de Bono de Viaje",
    en: "Discount Travel Voucher",
  },
  travelVouchersTab: {
    es: "Travel Vouchers",
    en: "Travel Vouchers",
  },
  addTravelVoucher: {
    es: "Crear Travel Voucher",
    en: "Create Travel Voucher",
  },
  addTravelVoucher__title: {
    es: "Crear Travel Voucher",
    en: "Create Travel Voucher",
  },
  voucherAmount: {
    es: "Monto",
    en: "Amount",
  },
  voucherCode: {
    es: "Código",
    en: "Code",
  },
  voucherStatus: {
    es: "Estado",
    en: "Status",
  },
  voucherEmail: {
    es: "Email",
    en: "Email",
  },
  sendCertificate: {
    es: "Enviar certificado por correo",
    en: "Send certificate by email",
  },
  sendCertificateYes: {
    es: "Enviar certificado por correo",
    en: "Send certificate by email",
  },
  sendCertificateNo: {
    es: "No enviar certificado",
    en: "Do not send certificate",
  },
  noTravelVouchers: {
    es: "Sin travel vouchers",
    en: "No travel vouchers",
  },
  addTravelVoucher__msg1: {
    es: "Travel voucher creado con éxito",
    en: "Travel voucher created successfully",
  },
  addTravelVoucher__msg2: {
    es: "Error al crear travel voucher",
    en: "Error creating travel voucher",
  },
  addTravelVoucher__msg3: {
    es: "El monto y el email son obligatorios",
    en: "Amount and email are required",
  },
  sendCertificate__msg1: {
    es: "Certificado enviado con éxito",
    en: "Certificate sent successfully",
  },
  sendCertificate__msg2: {
    es: "Error al enviar el certificado",
    en: "Error sending the certificate",
  },
  newMember: {
    es: "Nuevo Socio",
    en: "New Member",
  },
  validate__msg1: {
    es: `El campo "{{field}}" es requerido`,
    en: `The field "{{field}}" is required`,
  },
  validate__msg2: {
    es: "El asterisco (*) y el borde rojo indica campos obligatorios que deben completarse antes de que puedas continuar.",
    en: "The asterisk (*) and red border indicate required fields that must be completed before you can continue.",
  },
  validationError: {
    es: "Error de Validación",
    en: "Validation Error",
  },
  errorGeneric: {
    es: "Error al crear datos, intente de nuevo o contacte con soporte",
    en: "Error creating data, try again or contact support",
  },
  validate__msg3: {
    es: "Los cotitulares son opcionales al capturar un nuevo contrato. Sin embargo, si decides agregar un cotitular, se requieren tanto el nombre como el apellido.",
    en: `Co-owners are optional when capturing a new contract. However, if you choose to add a co-owner, both the first and last name fields are required.`,
  },
  warning: {
    es: "Aviso",
    en: "Warning",
  },
  validate__msg4: {
    es: "Amigos y Familiares son opcionales. Si decides agregarlos, se requieren los campos de nombre, apellido y relación con el titular/cotitular.",
    en: `Friends and Family are optional. If you choose to add them, the fields for first name, last name, and relationship with the owner/co-owner are required.`,
  },
  validate__msg4__ext1: {
    es: "Valide todos los campos de Friends and Family e intente enviar de nuevo.",
    en: `Validate all Friends and Family fields and try submitting again.`,
  },
  validate__msg5: {
    es: `El campo "{{field}}" requiere mínimo 3 caracteres`,
    en: `The field "{{field}}" requires a minimum of 3 characters`,
  },
  validate__msg6: {
    es: "Los incentivos de ventas y regalos son opcionales. Sin embargo, si se proporcionan, todos los campos deben completarse.",
    en: `Sales incentives and gifts are optional. However, if provided, all fields must be filled out.`,
  },
  okCreateAllCap: {
    es: "Contrato y socios creados con éxito.",
    en: "Contract and members created successfully.",
  },
  successfulOperation: {
    es: "Operación Exitosa",
    en: "Successful Operation",
  },
  listMembers: {
    es: "Listar Socios",
    en: "List Members",
  },
  changeStatusContract__mg1: {
    es: "Cancelar el estado del contrato",
    en: "Cancelar estado del contrato",
  },
  changeStatusContract__mg2: {
    es: "Procesar el estado del contrato",
    en: "Process contract status",
  },
  changeStatusContract__mg3: {
    es: "Pausar el estado del contrato",
    en: "Pause contract status",
  },
  changeStatusContract__mg4: {
    es: "¿Desea cambiar el estado del contrato a {{status}}?",
    en: "Do you want to change the contract status to {{status}}?",
  },
  changeStatusContract__mg5: {
    es: "Estado del contrato cambiado con éxito",
    en: "Contract status changed successfully",
  },
  generateDocuments: {
    es: "Generar documentos",
    en: "Generate documents",
  },
  contractAndOwners: {
    es: "Licencia de Usuario",
    en: "End User License",
  },
  uploadDocuments: {
    es: "Subir documentos",
    en: "Upload documents",
  },
  upload: {
    es: "Subir",
    en: "Upload",
  },
  documentGeneratedSuccessfully: {
    es: "Documento generado con éxito",
    en: "Document generated successfully",
  },
  documentGeneratedError: {
    es: "Error al generar el documento",
    en: "Error generating document",
  },
  documentUploadSuccessfully: {
    es: "Documento subido con éxito",
    en: "Document uploaded successfully",
  },
  documentUploadError: {
    es: "Error al subir el documento",
    en: "Error uploading document",
  },
  listDocuments: {
    es: "Documentos subidos",
    en: "Uploaded Documents",
  },
  clickToUpload: {
    es: "Click para subir",
    en: "Click to upload",
  },
  userNotExists: {
    es: "El usuario no existe",
    en: "Username does not exist",
  },
  errorLogin: {
    es: "Error al iniciar sesión",
    en: "Failed to login",
  },
  wrongPassword: {
    es: "Contraseña errónea",
    en: "Wrong password",
  },
  rgxOnlyTextAndSpace: {
    es: "Solo se acepta letras y espacio",
    en: "Only letters and space are accepted",
  },
  rgxOnlyTextAndGuion: {
    es: "Solo se acepta letras, números y guion (-)",
    en: "Only letters, numbers and hyphen (-) are accepted",
  },
  rgxEmail: {
    es: "Correo electrónico incorrecto",
    en: "Incorrect email",
  },
  rgxCityAndAddress: {
    es: "Solo se acepta letras, números, espacios y comas",
    en: "Only letters, numbers, spaces and commas are accepted",
  },
  rgxZip: {
    es: "Solo acepta números, espacios y guiones",
    en: "Only accepts numbers, spaces and hyphens",
  },
  validate__msg7: {
    es: `El campo "{{field}}" no acepta valores negativos o igual a cero`,
    en: `The field "{{field}}" does not accept negative values ​​or values ​​equal to zero`,
  },
  email__err1: {
    es: "El correo electrónico del titular y co titular no pueden ser iguales",
    en: "The email address of the owner and co-owner cannot be the same",
  },
  email__err2: {
    es: `El correo electrónico "{{email}}" ya esta creado en nuestra base de datos`,
    en: `The email "{{email}}" is already created in our database`,
  },
  email__err3: {
    es: `El correo electrónico con formato no válido`,
    en: `Invalid email format`,
  },
  friendsFamily__email_required: {
    es: `El correo electrónico del Friends & Family es obligatorio`,
    en: `The email address of the Friends & Family is required`,
  },
  friendsFamily__duplicate: {
    es: `Este correo electrónico ya está registrado`,
    en: `This email address is already registered`,
  },
  friendsFamily__create_error: {
    es: `Error al crear el Friends & Family`,
    en: `Error creating Friends & Family`,
  },
  friendsFamily__ageWarningTitle: {
    es: `Friends & Family: solo mayores de 18 años`,
    en: `Friends & Family: adults only (18+)`,
  },
  friendsFamily__ageWarningMessage: {
    es: `El programa Friends & Family es exclusivo para personas mayores de 18 años. Enviaremos una invitación al correo registrado y el F&F deberá aceptarla antes de quedar aprobado.`,
    en: `The Friends & Family program is for people aged 18 or older. We will send an invitation to the registered email and the F&F must accept it before being approved.`,
  },
  friendsFamily__ageWarningCheck: {
    es: `Confirmo que es mayor de 18 años`,
    en: `I confirm they are 18 years or older`,
  },
  friendsFamily__ageWarningConfirm: {
    es: `Registrar y enviar invitación`,
    en: `Register and send invitation`,
  },
  friendsFamily__ageWarningCancel: {
    es: `Cancelar`,
    en: `Cancel`,
  },
  friendsFamily__invitationSent: {
    es: `Friends & Family registrado. Se envió la invitación por correo.`,
    en: `Friends & Family registered. The email invitation was sent.`,
  },
  friendsFamily__invitationNote: {
    es: `La invitación se envía por correo y debe aceptarse desde ese enlace.`,
    en: `The invitation is sent by email and must be accepted from that link.`,
  },
  friendsFamily__invitationStatus: {
    es: `Invitación`,
    en: `Invitation`,
  },
  friendsFamily__invitationPending: {
    es: `Pendiente`,
    en: `Pending`,
  },
  friendsFamily__invitationAccepted: {
    es: `Aprobado`,
    en: `Approved`,
  },
  friendsFamily__invitationExpired: {
    es: `Expirada`,
    en: `Expired`,
  },
  friendsFamily__invitationRevoked: {
    es: `Revocada`,
    en: `Revoked`,
  },
  friendsFamily__invitationNoEmail: {
    es: `Sin correo`,
    en: `No email`,
  },
  friendsFamily__resendInvitation: {
    es: `Reenviar invitación`,
    en: `Resend invitation`,
  },
  friendsFamily__revokeInvitation: {
    es: `Revocar`,
    en: `Revoke`,
  },
  friendsFamily__resendConfirm: {
    es: `Se generará un enlace nuevo y el anterior dejará de funcionar. ¿Reenviar la invitación?`,
    en: `A new link will be generated and the previous one will stop working. Resend the invitation?`,
  },
  friendsFamily__revokeConfirm: {
    es: `El enlace de invitación dejará de funcionar. ¿Revocar la invitación?`,
    en: `The invitation link will stop working. Revoke the invitation?`,
  },
  friendsFamily__resendOk: {
    es: `Invitación reenviada correctamente`,
    en: `Invitation resent successfully`,
  },
  friendsFamily__revokeOk: {
    es: `Invitación revocada correctamente`,
    en: `Invitation revoked successfully`,
  },
  friendsFamily__invitationError: {
    es: `No se pudo completar la acción sobre la invitación`,
    en: `The invitation action could not be completed`,
  },
  friendsFamily__emailChangeWarning: {
    es: `Si cambias el correo, el F&F deberá aceptar una nueva invitación.`,
    en: `If you change the email, the F&F must accept a new invitation.`,
  },
  paymentLinkStatus: {
    es: "Estado de Enlace",
    en: "Link Status",
  },
  lifetime: {
    es: "Lifetime",
    en: "Lifetime",
  },
  fiendsAndFamily: {
    es: "Friends and Family",
    en: "Friends and Family",
  },
  role: {
    es: "Rol",
    en: "Role",
  },
  createUser: {
    es: "Crear usuario",
    en: "Create user",
  },
  password: {
    es: "Contraseña",
    en: "Password",
  },
  createRole: {
    es: "Crear rol",
    en: "Create role",
  },
  createRole__type: {
    es: "Seleccione un tipo de rol",
    en: "Choose a role type",
  },
  createRole__staff: {
    es: "Seleccione los módulos para el Staff",
    en: "Select the modules for the Staff",
  },
  createRole__permissions: {
    es: "Seleccione los permisos",
    en: "Select permissions",
  },
  createRole__club: {
    es: "Seleccione los clubes",
    en: "Select clubs",
  },
  notDefined: {
    es: "No definido",
    en: "Not defined",
  },

  confirm: {
    es: "Confirmar",
    en: "Confirm",
  },
  membership: {
    es: "Membresía",
    en: "Membership",
  },
  memberships: {
    es: "Membresías",
    en: "Memberships",
  },
  weeksVipYear: {
    es: "Semanas VIP por año",
    en: "Vip Weeks per Year",
  },
  weeksSmartYear: {
    es: "Semanas Smart por año",
    en: "Smart Weeks per Year",
  },
  weeksMinuteYear: {
    es: "Semanas de último minuto por año",
    en: "Last Minute Weeks per Year",
  },
  coin: {
    es: "MX",
    en: "USD",
  },
  date: {
    es: "Fecha",
    en: "Date",
  },
  filtersBookings__reference: {
    es: "Buscar por Referencia...",
    en: "Search by Reference...",
  },
  filtersBookings__resort: {
    es: "Buscar por Resort...",
    en: "Search by Resort...",
  },
  filtersBookings__client: {
    es: "Buscar por Cliente...",
    en: "Search by Client...",
  },
  filtersBookings__user: {
    es: "Buscar por Usuario...",
    en: "Search by User...",
  },
  filtersBookings__agent: {
    es: "Buscar por Agente...",
    en: "Search by Agent...",
  },
  filtersBookings__status: {
    es: "Buscar por Estado...",
    en: "Search by Status...",
  },
  filtersBookings__date: {
    es: "Buscar por Fecha...",
    en: "Search by Date...",
  },
  filtersBookings__checkIn: {
    es: "Buscar por CheckIn...",
    en: "Search by CheckIn...",
  },
  filtersBookings__loginId: {
    es: "Buscar por LoginID...",
    en: "Search by LoginID...",
  },
  filtersBookings__country: {
    es: "Buscar por País del Resort...",
    en: "Search by Resort Country...",
  },
  filtersBookings__city: {
    es: "Buscar por Ciudad del Resort...",
    en: "Search by Resort City...",
  },
  reserveDetails: {
    es: "Detalles de la Semana",
    en: "Week Details",
  },
  lytc: {
    es: "Licencia de Usuario",
    en: "End User License",
  },
  cont: {
    es: "Contrato",
    en: "Contract",
  },
  additionalPayments: {
    es: "Pagos Adicionales",
    en: "Additional Payments",
  },
  priceContract: {
    es: "Precio de Venta",
    en: "Price",
  },
  administrationCost: {
    es: "Costo Administrativo",
    en: "Contract Cost",
  },
  initialPayment: {
    es: "Pago Inicial",
    en: "Initial Payment",
  },
  downPaymentPercentage: {
    es: "Porcentaje de Pago Inicial",
    en: "Down Payment Percentage",
  },
  balance: {
    es: "Saldo",
    en: "Balance",
  },
  monthlyPayments: {
    es: "Número de Mensualidades",
    en: "Monthly Installments",
  },
  monthlyPayment: {
    es: "Pago mensual",
    en: "Monthly payment",
  },
  firstMonthlyDate: {
    es: "Fecha primera mensualidad",
    en: "First Monthly Payment",
  },
  interestRate: {
    es: "Interés",
    en: "Interest",
  },
  conditionalDownPayment: {
    es: "Pago Inicial Condicional",
    en: "Conditional Down Payment",
  },
  conditionalDownPayment__msg1: {
    es: "Solo se acepta cinco (3) pagos iniciales condicionales",
    en: "Only five (3) conditional initial payments are accepted",
  },
  additionalPayments__msg1: {
    es: "Solo se acepta cinco (3) pagos iniciales",
    en: "Only five (3) initial payments are accepted",
  },
  detailsContract: {
    es: "Detalles del Contrato",
    en: "Contract Details",
  },
  fraf: {
    es: "Friends and Family",
    en: "Friends and Family",
  },
  ma: {
    es: "Acuerdo de Membresía",
    en: "Membership Agreement",
  },
  ppaa: {
    es: "Adenda al Plan de Pagos (Affirm)",
    en: "Payment Plan Addendum Affirm",
  },
  ppab: {
    es: "Adenda al Plan de Pagos (Interno)",
    en: "Payment Plan Addendum In House",
  },
  pda: {
    es: "Reconocimiento de Compra y Divulgación",
    en: "Purchase & Disclosure Acknowledgment",
  },
  rca: {
    es: "Autorización de Cargo Recurrente",
    en: "Recurring Charge Authorization",
  },
  adp: {
    es: "ADP",
    en: "ADP",
  },
  cdp: {
    es: "CDP",
    en: "CDP",
  },
  acre: {
    es: "ADP",
    en: "ADP",
  },
  ocvi: {
    es: "Compra de de Villa",
    en: "Villa Purchase",
  },
  opra: {
    es: "Cash Out",
    en: "Cash Out",
  },
  paga: {
    es: "Pagaré",
    en: "Promissory Note",
  },
  reba: {
    es: "CDP",
    en: "CDP",
  },
  allFieldsAreRequired: {
    es: "Todos los campos son requeridos",
    en: "All fields are required",
  },
  fieldsComplete: {
    es: "¿Deseas activar la membresía ahora?",
    en: "Do you want to activate membership now?",
  },
  fieldsIncomplete: {
    es: "¿Seguro que quieres activar? Faltan los siguientes campos por completar",
    en: "Are you sure you want to activate? The following fields are missing to complete",
  },
  promotions: {
    es: "Promociónes",
    en: "Promotions",
  },
  promotionCode: {
    es: "Código Promocion",
    en: "Promotion Code",
  },
  form: {
    es: "Registrar F&F",
    en: "F&F Register",
  },
  confirmChangeStatusContract: {
    es: "¿Seguro que quieres cambiar el estado del contrato?",
    en: "Are you sure you want to change the contract status?",
  },
  chooseRelationship: {
    es: "Selecciona el parentesco",
    en: "Select the relationship",
  },
  changeLenguage: {
    es: "Cambiar idioma",
    en: "Change language",
  },
  options: {
    es: "Opciones",
    en: "Options",
  },
  selectAnOption_: {
    es: "Seleccione una opción para recibir el link",
    en: "Select an option to receive the link",
  },
  selectType: {
    es: "Seleccione un metodo",
    en: "Select a method",
  },
  /* Seccion de statistic */
  renewalsReporting: {
    es: "Reportería de Renovaciones",
    en: "Renewals Reporting",
  },
  recoveryTeam: {
    es: "Recuperación de Cuenta",
    en: "Recovery Team",
  },
  totalWeklyProduction: {
    es: "Producción Semanal Total",
    en: "Weekly Total Production",
  },
  salesVolume: {
    es: "Volumen de Ventas",
    en: "Sales Volume",
  },
  appliedPromotions: {
    es: "Promociones Aplicadas",
    en: "Applied Promotions",
  },
  apply: {
    es: "Aplicar",
    en: "Apply",
  },
  delete: {
    es: "Borrar",
    en: "Delete",
  },
  averageTicket: {
    es: "Ticket Promedio",
    en: "Average Ticket",
  },
  conversionRate: {
    es: "Tasa de Conversión",
    en: "Conversion Rate",
  },
  yearsTicket: {
    es: "Años por Ticket",
    en: "Years per Ticket",
  },
  newClinets: {
    es: "Nuevos Clientes",
    en: "New Clients",
  },
  retentionRate: {
    es: "Tasa de Retención",
    en: "Retention Rate",
  },
  filterByDate: {
    es: "Filtrar por fecha",
    en: "Filter by date",
  },
  renewalPeymentLink: {
    es: "Enlace de Pago de Renovaciones",
    en: "Recovery Payment Link",
  },
  paymantDetails: {
    es: "Detalles del Pago",
    en: "Payment Details",
  },
  /* Equipo de recuperación de cuentas */
  recoveredAccounts: {
    es: "Cuentas Recuperadas",
    en: "Recovered Accounts",
  },
  recoveryRate: {
    es: "Tasa de Recuperación",
    en: "Recovery Rate",
  },
  yearsForgiven: {
    es: "Años Condonados",
    en: "Years forgiven",
  },
  amountRecovered: {
    es: "Monto Recuperado",
    en: "Amount Recovered",
  },
  averageRecoveryTime: {
    es: "Tiempo Promedio de Recuperación",
    en: "Average Recovery Time",
  },
  analysisofExpiryReasons: {
    es: "Análisis de Razones de Vencimiento",
    en: "Analysis of Expiry Reasons",
  },
  markAll: {
    es: "Marcar todos",
    en: "Mark all",
  },
  unmarkAll: {
    es: "Desmarcar todos",
    en: "Unmark all",
  },
  selectAll: {
    es: "Seleccionar todos",
    en: "Select all",
  },
  unselectAll: {
    es: "Deseleccionar todos",
    en: "Unselect all",
  },
  reasign: {
    es: "Reasignar",
    en: "Reassign",
  },
  assignedAt: {
    es: "Fecha de Asignación",
    en: "Asign date",
  },
  reassignment: {
    es: "Reasignación",
    en: "Reassignment",
  },
  noMembersFound: {
    es: "No se encontraron socios, revise los filtros de búsqueda",
    en: "No members found, check your search filters",
  },
  discard: {
    es: "Descartar",
    en: "Discard",
  },
  upDownContract: {
    es: "Upgrade/Downgrade",
    en: "Upgrade/Downgrade",
  },
  questionPreAction: {
    es: "¿Desea realizar esta acción?",
    en: "Do you want to perform this action?",
  },
  MonthlyInterestRate: {
    es: "Interés Mensual",
    en: "Monthly Interest",
  },
  remove: {
    es: "Eliminar",
    en: "Remove",
  },
  validate__msg8_numberContract: {
    es: `El Numero de Contrato ya existe`,
    en: `The Contract Number already exists`,
  },
  validate__msg9_loginId: {
    es: `El LoginID ya existe`,
    en: `The LoginID already exists`,
  },
  /*Actions Member*/
  loading: {
    es: "Cargando...",
    en: "Loading...",
  },
  sendWelcomeEmail: {
    es: "Enviar Correo de Bienvenida",
    en: "Send Welcome Email",
  },
  descSendWelcmomeEmail: {
    es: "Enviar un correo electrónico de bienvenida al activar la membresía",
    en: "Send a welcome email upon membership activation",
  },
  openProfile: {
    es: "Abrir Perfil en Portal",
    en: "Open Profile in Portal",
  },
  descOpenProfile: {
    es: "Abrir el perfil del socio en el portal web",
    en: "Open member profile in the web portal",
  },
  openProfile__msg1: {
    es: "¿Desea abrir el perfil del titular o co-titular?",
    en: "Do you want to open the owner or co-owner profile?",
  },
  sendPasswordRecoveryEmail: {
    es: "Enviar token de recuperación de contraseña",
    en: "Send a unique password recovery token",
  },
  descPasswordRecoveryEmail: {
    es: "Enviar token unico de recuperación de contraseña por correo electrónico",
    en: "Send a unique password recovery token by email",
  },
  sendCustomEmail: {
    es: "Enviar Correo Personalizado",
    en: "Send Custom Email",
  },
  setSequenceEmails: {
    es: "Establecer Secuencia Correos",
    en: "Set Sequence Emails",
  },
  cancelSequenceEmails: {
    es: "Cancelar Secuencia de Correos",
    en: "Cancel Sequence Emails",
  },
  sendCampaignEmail: {
    es: "Enviar Campaña de Correos",
    en: "Send Campaign Emails",
  },
  validate__msg10_saldo: {
    es: `El saldo no puede ser menor a cero`,
    en: `The balance cannot be less than zero`,
  },
  validate__msg11_cdp: {
    es: `En los CDP, el Monto y Fecha son obligatorios`,
    en: `In CDPs, the Amount and Date are mandatory`,
  },
  validate__msg12_adp: {
    es: `En los ADP, el Monto y Fecha son obligatorios`,
    en: `In ADPs, the Amount and Date are mandatory`,
  },
  discountCodes: {
    es: "Códigos de descuento",
    en: "Discount codes",
  },
  catalogs: {
    es: "Catálogos",
    en: "Catalogs",
  },
  fileName: {
    es: "Nombre del Archivo",
    en: "File Name",
  },
  fileformat: {
    es: "Formato ",
    en: "Format",
  },
  dateUpload: {
    es: "Fecha de Subida",
    en: "Date Upload",
  },
  pendingActivation: {
    es: "Pendiente por Activar",
    en: "Pending Activation",
  },
  confirmActivation: {
    es: "Confirmar activación",
    en: "Confirm activation",
  },
  membershipActivatedOk: {
    es: "Membresía activada con éxito",
    en: "Membership activated successfully",
  },
  document: {
    es: "Documento",
    en: "Document",
  },
  uploadedBy: {
    es: "Subido por",
    en: "Uploaded by",
  },
  uploadDocument: {
    es: "Subir documento",
    en: "Upload document",
  },
  downloadDocument: {
    es: "Descargar documento",
    en: "Download document",
  },
  removeDocument: {
    es: "Eliminar documento",
    en: "Remove document",
  },
  pendingUpload: {
    es: "Pendiente por Subir",
    en: "Pending Upload",
  },
  uploadedDocument: {
    es: "Documento Subido",
    en: "Uploaded Document",
  },
  generateDocument: {
    es: "Generar Documento",
    en: "Generate Document",
  },
  documentRemovedSuccessfully: {
    es: "Documento eliminado con éxito",
    en: "Document successfully deleted",
  },
  documentRemovedError: {
    es: "Error al eliminar el documento",
    en: "Error deleting document",
  },
  activateMembership: {
    es: "Activar membresía",
    en: "Activate membership",
  },
  validateMemberData: {
    es: "Validar datos de contacto",
    en: "Validate contact details",
  },
  validateMemberData__mgs1: {
    es: "Por favor, valida que la información capturada sea correcta",
    en: "Please validate that the information captured is correct",
  },
  continue: {
    es: "Continuar",
    en: "Continue",
  },
  correct: {
    es: "Corregir",
    en: "Correct",
  },
  createRole__msg1: {
    es: "Rol creado con éxito",
    en: "Successfully created role",
  },
  closingCost: {
    es: "Gastos Legales",
    en: "Closing Cost",
  },
  authorizationPayments: {
    es: "Autorización para Pagos Mensuales",
    en: "Authorization for Monthly Payments",
  },
  upgrade: {
    es: "Upgrade",
    en: "Upgrade",
  },
  downgrade: {
    es: "Downgrade",
    en: "Downgrade",
  },
  upgradeDowngradeOk: {
    es: "Upgrade/Downgrade exitoso",
    en: "Upgrade/Downgrade successful",
  },
  processingFee: {
    es: "Cuota de Procesamiento",
    en: "Processing Fee",
  },
  sixTax: {
    es: "6% Impuestos",
    en: "6% Occupancy Tax",
  },
  total: {
    es: "Total",
    en: "Total",
  },
  seller: {
    es: "Vendedor",
    en: "Seller",
  },
  changeLanguageContract: {
    es: "¿Desea cambiar el idioma del contrato?",
    en: "Do you want to change the language of the contract?",
  },
  changeLanguageContract__msg1: {
    es: "Idioma cambiado con éxito",
    en: "Language changed successfully",
  },
  allRightReserved: {
    es: "Todos los derechos reservados",
    en: "All rights reserved",
  },
  reportBug: {
    es: "Reportar Error",
    en: "Report Bug",
  },
  changeLenguage__msg1: {
    es: "Presiona para cambiar el idioma",
    en: "Press to change the language",
  },
  reportBug__msg1: {
    es: "Grabando Error...",
    en: "Recording Error...",
  },
  reportBug__msg2: {
    es: "Detener grabación",
    en: "Stop recording",
  },
  reportBug__msg3: {
    es: "A continuación se habilitará el modo de <b>grabar pantalla</b> para reportar el error, una vez escriba una breve descripción",
    en: "Next, the <b>screen recording</b> mode will be enabled to report the error, once write a short description",
  },
  iUnderstand: {
    es: "¡Lo entiendo!",
    en: "I understand!",
  },
  reportBug__msg4: {
    es: "Escribe una breve descripción del error: ",
    en: "Write a brief description of the bug:",
  },
  reportBug__msg5: {
    es: "Explica de manera breve el error...",
    en: "Briefly explain the error...",
  },
  reportBug__msg6: {
    es: "Error reportado con éxito",
    en: "Error reported successfully",
  },
  assigned: {
    es: "Asignado",
    en: "Assigned",
  },
  renewalAssignRemove: {
    es: "Eliminar asignaciones",
    en: "Delete assignments",
  },
  totalSelected: {
    es: "Total seleccionados",
    en: "Total selected",
  },
  sendLinkPayment: {
    es: "Enviar Enlace de Pago",
    en: "Send Payment Link",
  },
  notFound: {
    es: "No encontrado",
    en: "Not found",
  },
  syncContactInBitrix: {
    es: "Sincronizar contacto en Bitrix24",
    en: "Sync contact in Bitrix24",
  },
  syncContactInBitrix_msg1: {
    es: "Crea el contacto en Bitrix24",
    en: "Create the contact in Bitrix24",
  },
  syncContactInBitrix_msg2: {
    es: "Contacto creado con éxito",
    en: "Contact created successfully",
  },
  priceTotal: {
    es: "Precio Total",
    en: "Total Price",
  },
  contact: {
    es: "Contacto",
    en: "Contact",
  },
  reputation: {
    es: "Reputación",
    en: "Reputation",
  },
  nights: {
    es: "Noches",
    en: "Nights",
  },
  kitchen: {
    es: "Cocina",
    en: "Kitchen",
  },
  occupancyMax: {
    es: "Ocupación Max.",
    en: "Max. Occupancy",
  },
  people: {
    es: "Personas",
    en: "People",
  },
  notesImportant: {
    es: "Notas Importantes",
    en: "Important Notes",
  },
  duration: {
    es: "Duración",
    en: "Duration",
  },
  price: {
    es: "Precio",
    en: "Price",
  },
  discountCode: {
    es: "Código de descuento",
    en: "Discount code",
  },
  discount: {
    es: "Descuento",
    en: "Discount",
  },
  create: {
    es: "Crear",
    en: "Create",
  },
  paymentLink__msg1: {
    es: "Ya existe un enlace de pago",
    en: "A payment link already exists",
  },
  copyPaymentLink: {
    es: "Copiar enlace de pago",
    en: "Copy payment link",
  },
  copyPaymentLink__msg1: {
    es: "Enlace de pago copiado con éxito",
    en: "Payment link successfully copied",
  },
  sendLinkPayment__msg1: {
    es: "Enlace de pago reenviado con éxito",
    en: "Payment link successfully resent",
  },
  sendLinkPayment__msg2: {
    es: "Error al reenviar enlace de pago",
    en: "Error resending payment link",
  },
  cancelLinkPayment: {
    es: "Cancelar enlace de pago",
    en: "Cancel payment link",
  },
  cancelLinkPayment__msg1: {
    es: "Enlace de pago cancelado con éxito",
    en: "Payment link successfully cancelled",
  },
  cancelLinkPayment__msg2: {
    es: "Error al cancelar enlace de pago",
    en: "Error cancelling payment link",
  },
  sendMailToRenewal: {
    es: "Enviar correo a",
    en: "Send email to",
  },
  both: {
    es: "Ambos",
    en: "Both",
  },
  forgiveDebt: {
    es: "Condonar deuda",
    en: "Forgive debt",
  },
  login: {
    es: "Iniciar Sesión",
    en: "Log In",
  },
  paymentLink__paid: {
    es: "Pago realizado con éxito",
    en: "Payment made successfully",
  },
  paymentLink__canceled: {
    es: "Pago cancelado o expirado",
    en: "Payment link canceled or expired",
  },
  externalPayment: {
    es: "Pago Externo",
    en: "External Payment",
  },
  externalPayment__msg1: {
    es: "Pago externo creado con éxito",
    en: "External payment created successfully",
  },
  externalPayment__msg2: {
    es: "Error al crear pago externo",
    en: "Error creating external payment",
  },
  yearsCondoned: {
    es: "Años Condonados",
    en: "Years Condoned",
  },
  newPeriod: {
    es: "Nuevo Periodo",
    en: "New Period",
  },
  condoned: {
    es: "Condonados",
    en: "Condoned",
  },
  noAnnuities: {
    es: "Sin anualidades",
    en: "No annuities",
  },
  addPaymentDeferred: {
    es: "Agregar Pago Diferido",
    en: "Add Deferred Payment",
  },
  totalPayment: {
    es: "Total Pago",
    en: "Total Payment",
  },
  addPaymentDeferred__msg1: {
    es: "Pago diferido creado con éxito",
    en: "Deferred payment created successfully",
  },
  addPaymentDeferred__msg2: {
    es: "Error al crear pago diferido",
    en: "Error creating deferred payment",
  },
  paymentsDeferred: {
    es: "Pagos diferidos",
    en: "Deferred payments",
  },
  amountPaid: {
    es: "Monto pagado",
    en: "Amount paid",
  },
  totalToPayment: {
    es: "Total a Pagar",
    en: "Total to Pay",
  },
  completePayment: {
    es: "Completar Pago",
    en: "Complete Payment",
  },
  missingAmount: {
    es: "Monto Faltante",
    en: "Missing Amount",
  },
  paymentCompleted: {
    es: "Pago Completado",
    en: "Payment Completed",
  },
  amountToPay: {
    es: "Monto a Pagar",
    en: "Amount to Pay",
  },
  amountToPay__msg1: {
    es: "El monto a pagar es menor al monto faltante",
    en: "The amount to pay is less than the missing amount",
  },
  webTemporary: {
    es: "Web temporal",
    en: "Temporary web",
  },
  webTemporary__msg1: {
    es: "El acceso web temporal se ha actualizado con éxito",
    en: "The temporary web access has been updated successfully",
  },
  allowAccess: {
    es: "Permitir acceso",
    en: "Allow access",
  },
  allow: {
    es: "Permitir",
    en: "Allow",
  },
  allowWithoutValidate: {
    es: "Permitir sin validar",
    en: "Allow without validate",
  },
  notAllow: {
    es: "No permitir",
    en: "Not allow",
  },
  paymentLinkDeferred: {
    es: "Enlace de Pago Diferido",
    en: "Payment Link Deferred",
  },
  linkType: {
    es: "Tipo de Enlace",
    en: "Link Type",
  },
  deferred: {
    es: "Diferido",
    en: "Deferred",
  },
  notDeferred: {
    es: "Individual/Online",
    en: "Individual/Online",
  },
  subtype: {
    es: "Subtipo",
    en: "Subtype",
  },
  renewalStatistics: {
    es: "Estadísticas de Renovaciones",
    en: "Renewals Statistics",
  },
  totals: {
    es: "Totales",
    en: "Totals",
  },
  renewedYears: {
    es: "Años Renovados",
    en: "Renewed Years",
  },
  totalsPerYear: {
    es: "Totales por año",
    en: "Totals per Year",
  },
  shippingByAgent: {
    es: "Envíos por Agente",
    en: "Shipping by Agent",
  },
  shipments: {
    es: "Envíos",
    en: "Sent",
  },
  totalsPerAgent: {
    es: "Totales por Agente",
    en: "Totals per Agent",
  },
  multiple: {
    es: "Múltiple",
    en: "Multiple",
  },
  average: {
    es: "Promedio",
    en: "Average",
  },
  yearsToRenew: {
    es: "Años por renovar",
    en: "Years to renew",
  },
  deferredPaymentsPerAgent: {
    es: "Pagos diferidos por agente",
    en: "Deferred payments per agent",
  },
  deferredPaymentsPerAgentNotCompleted: {
    es: "Pagos diferidos por agente no completados",
    en: "Deferred payments per agent not completed",
  },
  sendEmailRenewals: {
    es: "¿Deseas enviar un total de {{total}} correos de renovación online?",
    en: "Do you want to send a total of {{total}} online renewal emails?",
  },
  sendLinkPaymentSelected: {
    es: "Enviar enlace de pago a seleccionados",
    en: "Send payment link to selected",
  },
  sendLinkPaymentAll: {
    es: "Enviar enlace de pago a todos",
    en: "Send payment link to all",
  },
  sendEmailRenewalsAll: {
    es: "¿Deseas a todos los de esta lista los correos de renovación online?",
    en: "Do you want everyone on this list to receive online renewal emails?",
  },
  shippingStatus: {
    es: "Estado de Envío",
    en: "Shipping Status",
  },
  shippingDate: {
    es: "Fecha de Envío",
    en: "Shipping Date",
  },
  onlineRenewalsSent__title: {
    es: "Renovaciones Online Enviadas",
    en: "Online Renewals Sent",
  },
  onlineRenewalsSent__msg1: {
    es: "Cada envió entrara en una cola, puede revisar el estado una vez finalizada la cola.",
    en: "Each sent will be in a queue, you can check the status once the queue is finished.",
  },
  other: {
    es: "Otro",
    en: "Other",
  },
  loginIdFound: {
    es: "LoginID encontrado",
    en: "LoginID found",
  },
  traveler: {
    es: "Viajero",
    en: "Traveler",
  },
  applyLoginId__fail: {
    es: "Aplique un LoginID",
    en: "Apply a LoginID",
  },
  applyLoginId__ok: {
    es: "LoginID aplicado",
    en: "LoginID applied",
  },
  applyLoginId__msg1: {
    es: "¿Desea aplicar este LoginID?",
    en: "Want to apply this LoginID?",
  },
  vrsys: {
    es: "VRSYS",
    en: "VRSYS",
  },
  concentrated: {
    es: "Concentrado",
    en: "Concentrated",
  },
  detailed: {
    es: "Detallado",
    en: "Detailed",
  },
  folio: {
    es: "Folio",
    en: "Folio",
  },
  exportToCsv__msg1: {
    es: "¿Desea exportar los resultados a un archivo CSV?",
    en: "Do you want to export the results to a CSV file?",
  },
  volumenRenewal: {
    es: "{{renewals}} Renovaciones pagadas con un total de $ {{total}} USD.",
    en: "{{renewals}} Renewals paid with a total of $ {{total}} USD.",
  },
  RenewalsSvailableToShip: {
    es: "Renovaciones Disponibles para Enviar",
    en: "Renewals Available to Ship",
  },
  TheLimitIsResetTo: {
    es: "El límite se restablece",
    en: "The limit is reset",
  },
  ownerAndCoOwner: {
    es: "Titular y Co-Titular",
    en: "Owner and Co-Owner",
  },
  editContract: {
    es: "Editar Contrato",
    en: "Edit Contract",
  },
  editContract__msg1: {
    es: "Contrato editado con éxito",
    en: "Contract edited successfully",
  },
  addCoOwner: {
    es: "Añadir Co-Titular",
    en: "Add Co-Owner",
  },
  addCoOwner__msg1: {
    es: "Co-Titular añadido con éxito",
    en: "Co-Owner added successfully",
  },
  addCoOwner__msg2: {
    es: "Error al añadir Co-Titular",
    en: "Error adding Co-Owner",
  },
  deleteCoOwner: {
    es: "Eliminar co-titular",
    en: "Delete co-owner",
  },
  deleteCoOwner__msg1: {
    es: "Co-Titular eliminado con éxito",
    en: "Co-Owner deleted successfully",
  },
  deleteCoOwner__msg2: {
    es: "Error al eliminar Co-Titular",
    en: "Error deleting Co-Owner",
  },
  deleteCoOwner__msg3: {
    es: "¿Desea eliminar el co-titular?",
    en: "Do you want to delete the co-owner?",
  },
  sendWelcomeEmail__msg1: {
    es: "Correo de bienvenida enviado con éxito.",
    en: "Welcome email sent successfully.",
  },
  sendPasswordRecoveryEmail__msg1: {
    es: "Correo de recuperación de contraseña enviado con éxito.",
    en: "Password recovery email sent successfully.",
  },
  lastLogin: {
    es: "Último inicio de sesión",
    en: "Last login",
  },
  editFee__msg1: {
    es: "Tarifa editada con éxito",
    en: "Fee edited successfully",
  },
  resetPassword__desc: {
    es: "Restablecer la contraseña del socio a la contraseña por defecto",
    en: "Reset the password of the member to the default password",
  },
  selectTypeMember: {
    es: "Seleccione el tipo de socio",
    en: "Select the type of member",
  },
  recoveryPassword__msg1: {
    es: "Selecciona el tipo de socio al que sera enviado el correo",
    en: "Select the type of member to whom the email will be sent",
  },
  resetPassword__msg1: {
    es: "Se restablecio la contraseña del socio a la contraseña por defecto",
    en: "Reset the password of the member to the default password",
  },
  resetPassword__msg2: {
    es: "Error al restablecer la contraseña",
    en: "Error resetting the password",
  },
  resetPassword__msg3: {
    es: "Selecciona el tipo de socio para restablecer la contraseña",
    en: "Select the type of member to reset the password",
  },
  payManual: {
    es: "Pago Manual",
    en: "Pay Manual",
  },
  holdWeek__msg1: {
    es: "Para continuar, debe introducir el LoginID del socio",
    en: "To continue, you must enter the LoginID of the member",
  },
  holdWeek__msg2: {
    es: "Membresía inactiva",
    en: "Membership inactive",
  },
  holdWeek__msg3: {
    es: "Contrato no procesado",
    en: "Contract not processed",
  },
  holdWeek__msg4: {
    es: "El contrato aun no ha sido procesado, contacte con soporte en caso de alguna duda.",
    en: "The contract has not been processed yet, contact support in case of any doubt.",
  },
  holdWeek__msg5: {
    es: "La membresía aun no has sido activada o ha expirado, contacte con soporte en caso de alguna duda.",
    en: "The membership has not been activated or has expired, contact support in case of any doubt.",
  },
  holdWeek__msg6: {
    es: "Al momento de emitir el pago deberás llenar todos los datos necesarios del viajero.",
    en: "At the moment of paying, you must fill in all the necessary data of the traveler.",
  },
  holdFast: {
    es: "Reserva rápida",
    en: "Hold Fast",
  },
  holdFast__msg1: {
    es: "Reserva rápida, realizada con éxito",
    en: "Hold Fast, successfully made",
  },
  holdFast__msg2: {
    es: "Error al realizar reserva rápida",
    en: "Error making hold fast",
  },
  customerPortfolioOld: {
    es: "Cartera de Clientes (ANTIGUO)",
    en: "Customer Portfolio (OLD)",
  },
  paymentStatus: {
    es: "Estado de Pago",
    en: "Payment Status",
  },
  charged: {
    es: "Cobrado",
    en: "Charged",
  },
  noCharged: {
    es: "No Cobrado",
    en: "Not Charged",
  },
  noAssignment: {
    es: "Sin Asignación",
    en: "No Assignment",
  },
  untableContracts: {
    es: "Contratos sin asignar",
    en: "Untable contracts",
  },
  removeAssignments: {
    es: "Eliminar asignaciones",
    en: "Remove assignments",
  },
  removeAssignments__msg1: {
    es: "¿Deseas remover un total de {{total}} asignaciones?",
    en: "Are you sure you want to remove {{total}} assignments?",
  },
  removeAssignments__msg2: {
    es: "Asignaciones removidas con éxito",
    en: "Assignments removed successfully",
  },
  removeAssignments__msg3: {
    es: "Error al remover asignaciones",
    en: "Error removing assignments",
  },
  massiveAssignContracts__msg3: {
    es: "Error al asignar contratos",
    en: "Error assigning contracts",
  },
  onlyAssigned: {
    es: "Solo asignados",
    en: "Only assigned",
  },
  assignments: {
    es: "Asignaciones",
    en: "Assignments",
  },
  year: {
    es: "Año",
    en: "Year",
  },
  notifySendNotifications: {
    es: "Enviar notificaciones",
    en: "Send notifications",
  },
  notifySendNotifications__msg1: {
    es: "Esta opción permite enviar notificaciones por correo electrónico y sms a los socios del contrato.",
    en: "This option allows you to send notifications by email and sms to the contract socios.",
  },
  nobody: {
    es: "Nadie",
    en: "Nobody",
  },
  submitted: {
    es: "Enviados",
    en: "Submitted",
  },
  results: {
    es: "Resultados",
    en: "Results",
  },
  notAvailable: {
    es: "No disponible",
    en: "Not available",
  },
  linkCopy__msg3: {
    es: "Error al copiar el enlace",
    en: "Error copying the link",
  },
  clubsSelected: {
    es: "Clubes seleccionados",
    en: "Clubs selected",
  },
  createPaymentsLinks__msg3: {
    es: "Los envios masivos suelen tardar, una vez realice algun envio masivo, debe esperar a que este finalice. Le mostraremos el estado de su solicitud.",
    en: "Massive sends often take a while, once you make a massive send, you must wait for it to finish. We will show you the status of your request.",
  },
  alert: {
    es: "Alerta",
    en: "Alert",
  },
  availableToSend: {
    es: "Disponible para enviar",
    en: "Available to send",
  },
  createPaymentsLinks__msg4: {
    es: "Seleccione al menos un contrato",
    en: "Select at least one contract",
  },
  availableToSend__msg1: {
    es: "Estado de envios",
    en: "Sending status",
  },
  pendingSend: {
    es: "Pendientes por enviar",
    en: "Pending to send",
  },
  closeMonth: {
    es: "Cerrar mes",
    en: "Close month",
  },
  currentMonth: {
    es: "Mes actual",
    en: "Current month",
  },
  closeMonth__msg1: {
    es: "Al cerrar la cartera, bien sea por fecha o por agente, todos los enlaces de pago generados por cualquier agente de renovaciones pasaran a ser online.",
    en: "When closing the portfolio, all payment links generated by any renewal agent will be closed.",
  },
  closeMonth__msg2: {
    es: "Error al cerrar la cartera",
    en: "Error closing the portfolio",
  },
  closeMonth__msg3: {
    es: "¿Desea cerrar el mes actual?",
    en: "Do you want to close the current month?",
  },
  closeMonth__msg4: {
    es: "Mes cerrado con éxito",
    en: "Month closed successfully",
  },
  createPaymentsLinks__msg5: {
    es: "Al crear los enlaces de pago, se tomara por defecto la tarifa de cada contrato.",
    en: "When creating the payment links, the default fee for each contract will be taken.",
  },
  currentRate: {
    es: "Tarifa actual",
    en: "Current rate",
  },
  createPaymentsLinks__msg6: {
    es: "Las notificaciones seran enviadas solo al titular del contrato.",
    en: "The notifications will be sent only to the owner of the contract.",
  },
  createPaymentsLinks__msg7: {
    es: "Las notificaciones seran enviadas solo al co-titular del contrato.",
    en: "The notifications will be sent only to the co-owner of the contract.",
  },
  createPaymentsLinks__msg8: {
    es: "Las notificaciones seran enviadas a ambos socios del contrato.",
    en: "The notifications will be sent to both owners of the contract.",
  },
  createPaymentsLinks__msg9: {
    es: "Las notificaciones no seran enviadas a nadie.",
    en: "The notifications will not be sent to anyone.",
  },
  sent: {
    es: "Enviado",
    en: "Sent",
  },
  opened: {
    es: "Abierto",
    en: "Open",
  },
  reference: {
    es: "Referencia",
    en: "Reference",
  },
  method: {
    es: "Método",
    en: "Method",
  },
  statsAdmin__msg1: {
    es: "La fecha de asignación no puede estar vacía",
    en: "The date of assignment cannot be empty",
  },
  noData: {
    es: "No hay datos",
    en: "No data",
  },
  noData__msg1: {
    es: "No hay datos para el periodo seleccionado",
    en: "No data for the selected period",
  },
  monthToClose: {
    es: "Mes a cerrar",
    en: "Month to close",
  },
  selectedStaff: {
    es: "Agentes seleccionados",
    en: "Selected agents",
  },
  massiveAssignContracts__msg4: {
    es: "¿Deseas asignar {{total}} contratos a {{totalStaff}} agentes?",
    en: "Do you want to assign {{total}} contracts to {{totalStaff}} agents?",
  },
  closeMonth__msg5: {
    es: "Estoy seguro de cerrar la cartera actual",
    en: "I'm sure to close the current portfolio",
  },
  noResults: {
    es: "Sin resultados",
    en: "No results",
  },
  closeMonth__msg6: {
    es: "Cerrar cuentas asignadas en el mes",
    en: "Close accounts assigned in the month",
  },
  canceled: {
    es: "Canceladas",
    en: "Canceled",
  },
  actives: {
    es: "Activas",
    en: "Active",
  },
  renovated: {
    es: "Renovado",
    en: "Renovated",
  },
  portfolioDate: {
    es: "Fecha de Cartera",
    en: "Portfolio Date",
  },
  portfolio: {
    es: "Cartera",
    en: "Portfolio",
  },
  sendToOwner: {
    es: "Enviar a titular",
    en: "Send to owner",
  },
  sendToCoOwner: {
    es: "Enviar a co-titular",
    en: "Send to co-owner",
  },
  sentToBoth: {
    es: "Enviado a ambos",
    en: "Sent to both",
  },
  created: {
    es: "Creado",
    en: "Created",
  },
  closePortfolio: {
    es: "Cerrar cartera",
    en: "Close portfolio",
  },
  closeMonth__msg7: {
    es: "Selecciona al menos una fecha de asginación o cartera",
    en: "Select at least one assignment or portfolio date",
  },
  selectedOptionActive: {
    es: "Seleccione una opción de activación",
    en: "Select an option of activation",
  },
  call: {
    es: "Llamada",
    en: "Call",
  },
  protocol: {
    es: "Protocolo",
    en: "Protocol",
  },
  lastShipment: {
    es: "Último envío",
    en: "Last shipment",
  },
  agentRenewal: {
    es: "Agente de Renovación",
    en: "Renewal Agent",
  },
  createdByMe__plurar: {
    es: "Creados por mi",
    en: "Created by me",
  },
  createdByMe__singular: {
    es: "Creado por mi",
    en: "Created by me",
  },
  createdByOthers__plurar: {
    es: "Creados por otros",
    en: "Created by others",
  },
  createdByOthers__singular: {
    es: "Creado por otros",
    en: "Created by others",
  },
  typeIndividual: {
    es: "Tipo: Individual",
    en: "Type: Individual",
  },
  club: {
    es: "Club",
    en: "Club",
  },
  columns: {
    es: "Columnas",
    en: "Columns",
  },
  noPayments: {
    es: "No hay pagos",
    en: "No payments",
  },
  addTutorial: {
    es: "Agregar tutorial",
    en: "Add tutorial",
  },
  addTutorial__msg1: {
    es: "Agregar una breve descripción",
    en: "Add a brief description",
  },
  addTutorial__msg2: {
    es: "Esto es un comentario de tutorial",
    en: "This is a tutorial comment",
  },
  addTutorial__msg3: {
    es: "Comentario creado con éxito",
    en: "Comment created successfully",
  },
  tutorialDate: {
    es: "Fecha de Tutorial",
    en: "Tutorial Date",
  },
  totalResult: {
    es: "Total resultados",
    en: "Total results",
  },
  activated: {
    es: "Activados",
    en: "Activated",
  },
  procesables: {
    es: "Procesables",
    en: "Procesables",
  },
  tutorial: {
    es: "Tutorial",
    en: "Tutorial",
  },
  deferredPayment: {
    es: "Pago diferido",
    en: "Deferred payment",
  },
  no: {
    es: "No",
    en: "No",
  },
  amountNoPayments: {
    es: "Monto sin pagos",
    en: "Amount without payments",
  },
  regular: {
    es: "Regular",
    en: "Regular",
  },
  renewedTotal: {
    es: "Total Renovado",
    en: "Renewed Total",
  },
  aSinglePayment: {
    es: "Un solo pago",
    en: "A single payment",
  },
  transactions: {
    es: "Transacciones",
    en: "Transactions",
  },
  totalCharged: {
    es: "Total Cobrado",
    en: "Total Charged",
  },
  indicator: {
    es: "Indicador",
    en: "Indicator",
  },
  breakdown: {
    es: "Desglose",
    en: "Breakdown",
  },
  day: {
    es: "Día",
    en: "Day",
  },
  month: {
    es: "Mes",
    en: "Month",
  },
  percentage: {
    es: "Porcentaje",
    en: "Percentage",
  },
  publics: {
    es: "Publicos",
    en: "Publics",
  },
  publicMembers: {
    es: "Socios públicos",
    en: "Public Members",
  },
  errorContract: {
    es: "Error al crear contrato",
    en: "Error creating contract",
  },
  errorContract__msg1: {
    es: "Error al crear contrato, intente de nuevo o contacte con soporte en caso de alguna duda.",
    en: "Error creating contract, try again or contact support in case of any doubt.",
  },
  guests: {
    es: "Invitados",
    en: "Guests",
  },
  guests__msg1: {
    es: "Crear un invitado",
    en: "Create a guest",
  },
  guests__msg2: {
    es: "Invitado creado con éxito",
    en: "Guest created successfully",
  },
  guests__msg3: {
    es: "Error al crear el invitado",
    en: "Error creating guest",
  },
  createMeeting: {
    es: "Crear reunión",
    en: "Create meeting",
  },
  deleteMeeting: {
    es: "Eliminar reunión",
    en: "Delete meeting",
  },
  meeting: {
    es: "Reunión",
    en: "Meeting",
  },
  meetingDate: {
    es: "Fecha",
    en: "Date",
  },
  meetingTime: {
    es: "Hora de Reunión",
    en: "Meeting Time",
  },
  meetingLink: {
    es: "Enlace",
    en: "Link",
  },
  guestMeetingDate: {
    es: "Fecha de reunión",
    en: "Meeting date",
  },
  timezoneNotice: {
    es: "ℹ️ Todas las fechas se muestran de forma consistente independientemente de tu zona horaria local",
    en: "ℹ️ All dates are displayed consistently regardless of your local timezone",
  },
  seatsLabel: {
    es: "asientos",
    en: "seats",
  },
  availableSeats: {
    es: "asientos disponibles",
    en: "available seats",
  },
  full: {
    es: "LLENO",
    en: "FULL",
  },
  selectMeeting: {
    es: "Seleccionar reunión",
    en: "Select meeting",
  },
  meetingCreated: {
    es: "Reunión creada exitosamente",
    en: "Meeting created successfully",
  },
  meetingDeleted: {
    es: "Reunión eliminada exitosamente",
    en: "Meeting deleted successfully",
  },
  errorLoadingMeetings: {
    es: "Error al cargar reuniones",
    en: "Error loading meetings",
  },
  errorCreatingMeeting: {
    es: "Error al crear reunión",
    en: "Error creating meeting",
  },
  errorDeletingMeeting: {
    es: "Error al eliminar reunión",
    en: "Error deleting meeting",
  },
  invalidUrl: {
    es: "El enlace debe ser una URL válida que inicie con https://",
    en: "The link must be a valid URL starting with https://",
  },
  meetingTimeExists: {
    es: "Ya existe una reunión con ese horario",
    en: "A meeting with that time already exists",
  },
  existingMeetingTimes: {
    es: "Horarios existentes",
    en: "Existing times",
  },
  noMeetingTimes: {
    es: "Aún no hay horarios registrados",
    en: "No times registered yet",
  },
  meetingTimeNotice: {
    es: "Los horarios se registran en hora del Este (EST).",
    en: "Times are registered in Eastern time (EST).",
  },
  used: {
    es: "Usado",
    en: "Used",
  },
  applyId__fail: {
    es: "Aplique un ID",
    en: "Apply a ID",
  },
  applyId__ok: {
    es: "ID aplicado",
    en: "ID applied",
  },
  applyId__msg1: {
    es: "¿Desea aplicar este ID?",
    en: "Want to apply this ID?",
  },
  idFound: {
    es: "ID encontrado",
    en: "ID found",
  },
  balanceFinanced: {
    es: "Saldo Financiado",
    en: "Financed Balance",
  },
  monthlyInstallments: {
    es: "Instalaciones Mensuales",
    en: "Monthly Installments",
  },
  firstInstallmentDate: {
    es: "Fecha de la Primera Instalación",
    en: "First Installment Date",
  },
  annualInterestRate: {
    es: "Tasa de Interés Anual",
    en: "Annual Interest Rate",
  },
  expireDatePromo: {
    es: "Fecha de vencimiento de promoción",
    en: "Promotion expiration date",
  },
  settingsSendRenewalsOnline: {
    es: "Configuración de envíos",
    en: "Shipping configuration",
  },
  myDealsAccess: {
    es: "Acceso MyDeals",
    en: "MyDeals access",
  },
  myDealsAccess__msg1: {
    es: "Acceso MyDeals cambiado",
    en: "MyDeals access changed",
  },
  closed: {
    es: "Cerradas",
    en: "Closed",
  },
  missingDeferred: {
    es: "Diferido Faltante",
    en: "Deferred missing",
  },
  certificates__msg4: {
    es: "Nuevo Certificado",
    en: "New Certificate",
  },
  // Financing tab translations
  financingDetails: {
    es: "Detalles del Financiamiento",
    en: "Financing Details",
  },
  contractPrice: {
    es: "Precio del Contrato",
    en: "Contract Price",
  },
  adminCost: {
    es: "Costo de Administración",
    en: "Administration Cost",
  },
  downPayment: {
    es: "Pago Inicial",
    en: "Down Payment",
  },
  firstPaymentDate: {
    es: "Fecha del Primer Pago",
    en: "First Payment Date",
  },
  interestFactor: {
    es: "Factor de Interés",
    en: "Interest Factor",
  },
  paymentDate: {
    es: "Fecha de Pago",
    en: "Payment Date",
  },
  paymentType: {
    es: "Tipo de Pago",
    en: "Payment Type",
  },
  requestId: {
    es: "ID de Solicitud",
    en: "Request ID",
  },
  paymentConfirmation: {
    es: "Confirmación de Pago",
    en: "Payment Confirmation",
  },
  financialSummary: {
    es: "Resumen Financiero",
    en: "Financial Summary",
  },
  totalContractValue: {
    es: "Valor Total del Contrato",
    en: "Total Contract Value",
  },
  totalPaid: {
    es: "Total Pagado",
    en: "Total Paid",
  },
  remainingBalance: {
    es: "Saldo Pendiente",
    en: "Remaining Balance",
  },
  // Payment Selector Modal translations
  selectPaymentConcepts: {
    es: "Seleccionar Conceptos de Pago",
    en: "Select Payment Concepts",
  },
  contractInfo: {
    es: "Información del Contrato",
    en: "Contract Information",
  },
  memberName: {
    es: "Nombre del Miembro",
    en: "Member Name",
  },
  concept: {
    es: "Concepto",
    en: "Concept",
  },
  commitment: {
    es: "Compromiso",
    en: "Commitment",
  },
  commitmentExplanation: {
    es: "Los pagos adicionales son compromisos de pago que se procesarán cuando el cliente complete la transacción.",
    en: "Additional payments are payment commitments that will be processed when the customer completes the transaction.",
  },
  additionalPayment: {
    es: "Pago Adicional",
    en: "Additional Payment",
  },
  additionalPaymentDesc: {
    es: "Monto personalizado adicional",
    en: "Additional custom amount",
  },
  custom: {
    es: "Personalizado",
    en: "Custom",
  },
  selectedConcepts: {
    es: "Conceptos Seleccionados",
    en: "Selected Concepts",
  },
  totalToPay: {
    es: "Total a Pagar",
    en: "Total to Pay",
  },
  additionalPaymentRequired: {
    es: "Debe ingresar un monto válido para el pago adicional",
    en: "Must enter a valid amount for additional payment",
  },
  // Payment Intent translations
  processingPayment: {
    es: "Procesando Pago",
    en: "Processing Payment",
  },
  paymentIntentCreated: {
    es: "Enlace de pago creado exitosamente",
    en: "Payment link created successfully",
  },
  errorCreatingPaymentIntent: {
    es: "Error al crear el enlace de pago",
    en: "Error creating payment link",
  },
  paymentProcessing: {
    es: "Su pago está siendo procesado",
    en: "Your payment is being processed",
  },
  paymentSuccessful: {
    es: "Pago realizado exitosamente",
    en: "Payment completed successfully",
  },
  paymentFailed: {
    es: "El pago falló. Intente nuevamente",
    en: "Payment failed. Please try again",
  },
  createPaymentLink: {
    es: "Crear Enlace de Pago",
    en: "Create Payment Link",
  },
  paymentIntentDetails: {
    es: "Detalles del Enlace de Pago",
    en: "Payment Link Details",
  },
  conceptsCount: {
    es: "Conceptos",
    en: "Concepts",
  },
  concepts: {
    es: "Pagos por concepto",
    en: "Payments by concept",
  },
  expirationDate: {
    es: "Fecha de Expiración",
    en: "Expiration Date",
  },
  noFinancingPayments: {
    es: "No hay pagos por contrato disponibles",
    en: "No contract payments available",
  },
  loadingFinancingPayments: {
    es: "Cargando pagos por contrato...",
    en: "Loading contract payments...",
  },
  errorLoadingFinancingPayments: {
    es: "Error al cargar los pagos por contrato",
    en: "Error loading contract payments",
  },
  succeeded: {
    es: "Completado",
    en: "Succeeded",
  },
  processing: {
    es: "Procesando",
    en: "Processing",
  },
  contractPaymentLinks: {
    es: "Enlaces de Pago del Contrato",
    en: "Contract Payment Links",
  },
  paymentLinkCreated: {
    es: "Enlace de pago creado y enviado por correo electrónico.",
    en: "Payment link created and sent via email.",
  },
  resendLink: {
    es: "Reenviar enlace",
    en: "Resend link",
  },
  resendLinkSuccess: {
    es: "Enlace de pago reenviado exitosamente.",
    en: "Payment link resent successfully.",
  },
  resendLinkError: {
    es: "Error al reenviar el enlace de pago.",
    en: "Error resending payment link.",
  },
  linkExpired: {
    es: "El enlace de pago ha expirado.",
    en: "Payment link has expired.",
  },
  generateSubscription: {
    es: "Generar Suscripción",
    en: "Generate Subscription",
  },
  // Financing Payments translations
  financingPayments: {
    es: "Pagos Financiados",
    en: "Financing Payments",
  },
  clear: {
    es: "Limpiar",
    en: "Clear",
  },
  export: {
    es: "Exportar",
    en: "Export",
  },
  clientName: {
    es: "Nombre del Cliente",
    en: "Client Name",
  },
  clientEmail: {
    es: "Email del Cliente",
    en: "Client Email",
  },
  subscriptionCreatedSuccess: {
    es: "Suscripción creada exitosamente. Se ha enviado el enlace por correo.",
    en: "Subscription created successfully. The link has been sent via email.",
  },
  contacts: {
    es: "Contactos",
    en: "Contacts",
  },
  TypeOfRegistration: {
    es: "Tipo de Registro",
    en: "Type of Registration",
  },
  affiliation: {
    es: "Afiliación",
    en: "Affiliation",
  },
  renewedUntil: {
    es: "Renovado hasta",
    en: "Renewed until",
  },
  refund: {
    es: "Disputado",
    en: "Disputed",
  },
  setting: {
    es: "Configuración",
    en: "Settings",
  },
  blocked: {
    es: "Bloqueado",
    en: "Blocked",
  },
  unlock: {
    es: "Desbloquear",
    en: "Unlock",
  },
  lock: {
    es: "Bloquear",
    en: "Lock",
  },
  location: {
    es: "Ubicación",
    en: "Location",
  },
  unlock__msg1: {
    es: "¿Desea desbloquear este Resort?",
    en: "Do you want to unlock this Resort?",
  },
  unlock__msg2: {
    es: "Resort desbloqueado con éxito",
    en: "Resort unlocked successfully",
  },
  unlock__msg3: {
    es: "Error al desbloquear Resort",
    en: "Error unlocking Resort",
  },
  unlock__msg4: {
    es: "Al desbloquear este resort, se restablecerán todo el inventario asociado a este resort en la siguiente descarga de inventario.",
    en: "By unlocking this resort, all inventory associated with this resort will be restored in the next inventory download.",
  },
  lock__msg1: {
    es: "¿Desea bloquear este Resort?",
    en: "Do you want to lock this Resort?",
  },
  lock__msg2: {
    es: "Resort bloqueado con éxito",
    en: "Resort locked successfully",
  },
  lock__msg3: {
    es: "Error al bloquear Resort",
    en: "Error locking Resort",
  },
  lock__msg4: {
    es: "Al bloquear el resort, se bloquearán todo el inventario que este disponible actualmente para este resort.",
    en: "By locking the resort, all the inventory that is currently available for this resort will be blocked.",
  },
  fixedInventory: {
    es: "¿Desea fijar este Inventario?",
    en: "Do you want to fix this Inventory?",
  },
  fixedInventory__msg1: {
    es: "Inventario fijado con éxito",
    en: "Inventory fixed successfully",
  },
  fixedInventory__msg2: {
    es: "Error al fijar Inventario",
    en: "Error fixing Inventory",
  },
  unfixedInventory: {
    es: "¿Desea desfijar este Inventario?",
    en: "Do you want to unfix this Inventory?",
  },
  unfixedInventory__msg1: {
    es: "Inventario desfijado con éxito",
    en: "Inventory unfixed successfully",
  },
  unfixedInventory__msg2: {
    es: "Error al desfijar Inventario",
    en: "Error unfixing Inventory",
  },
  downloadInventory: {
    es: "Descargar Inventario",
    en: "Download Inventory",
  },
  downloadInventory__msg1: {
    es: "¿Desea descargar el inventario?",
    en: "Do you want to download the inventory?",
  },
  downloadInventory__msg2: {
    es: "Descarga de inventario iniciada con éxito",
    en: "Inventory download started successfully",
  },
  downloadInventory__msg3: {
    es: "Error al iniciar la descarga de inventario",
    en: "Error starting inventory download",
  },
  syncContactInHubspot: {
    es: "Sincronizar contacto en Hubspot",
    en: "Sync contact in Hubspot",
  },
  syncContactInHubspot_msg1: {
    es: "Crea el contacto en Hubspot",
    en: "Create the contact in Hubspot",
  },
  syncContactInHubspot_msg2: {
    es: "Contacto creado con éxito",
    en: "Contact created successfully",
  },
  syncContactInHubspot_msg3: {
    es: "Logs - Sincronización Hubspot",
    en: "Logs - Sync Hubspot",
  },
  syncContactInHubspot_msg4: {
    es: "Nombre, Apellido Paterno y Email son obligatorios",
    en: "Name, Last name and Email are required",
  },
  syncContactInHubspot_msg5: {
    es: "Desea forzar la sincronización de contacto en Hubspot?",
    en: "Do you want to force the synchronization of the contact in Hubspot?",
  },
  syncContactInHubspot_msg6: {
    es: "Si, forzar",
    en: "Yes, force",
  },
  syncContactInHubspot_msg7: {
    es: "No, normal",
    en: "No, normal",
  },
  syncContactInHubspot_msg8: {
    es: "Seleccione una opción",
    en: "Select an option",
  },
  completeData: {
    es: "Completar Datos",
    en: "Complete Data",
  },
  certificates: {
    es: "Certificados",
    en: "Certificates",
  },
  couponsAndGifts: {
    es: "Cupones y regalos",
    en: "Coupons & gifts",
  },
  certificates__msg1: {
    es: "Crear un certificado",
    en: "Create a certificate",
  },
  certificates__msg2: {
    es: "Certificado creado con éxito",
    en: "Certificate created successfully",
  },
  folios: {
    es: "Folios",
    en: "Folios",
  },
  foliosMenu: {
    es: "Folios",
    en: "Folios",
  },
  folioCompra: {
    es: "Folio de compra",
    en: "Purchase reference",
  },
  disponible: {
    es: "Disponibles",
    en: "Available",
  },
  pack: {
    es: "Paquete",
    en: "Pack",
  },
  buy: {
    es: "Comprar",
    en: "Buy",
  },
  issueCertificate: {
    es: "Emitir certificado",
    en: "Issue certificate",
  },
  emittedCertificates: {
    es: "Certificados emitidos",
    en: "Issued certificates",
  },
  refresh: {
    es: "Actualizar",
    en: "Refresh",
  },
  foliosDisponibles: {
    es: "Folios disponibles",
    en: "Available folios",
  },
  foliosNoDisponibles: {
    es: "Sin folios disponibles",
    en: "No folios available",
  },
  certificates__msg3: {
    es: "Error al crear el certificado",
    en: "Error creating certificate",
  },
  catalogo: {
    es: "Catálogo",
    en: "Catalog",
  },
  tipoCuponCruises: {
    es: "Crucero",
    en: "Cruise",
  },
  createGuest: {
    es: "Crear Invitado",
    en: "Create Guest",
  },
  createGuest__msg1: {
    es: "Crear un Invitado",
    en: "Create a Guest",
  },
  createGuest__msg2: {
    es: "Invitado creado con éxito",
    en: "Guest created successfully",
  },
  createGuest__msg3: {
    es: "Error al crear el Invitado",
    en: "Error creating Guest",
  },
  accessWebMember: {
    es: "Acceso web",
    en: "Web access",
  },
  accessWebMember__msg1: {
    es: "El acceso web se ha actualizado con éxito",
    en: "The web access has been updated successfully",
  },
  generateURLOnline: {
    es: "Generar URL Online",
    en: "Generate Online URL",
  },
  generateURLOnline__confirm: {
    es: "Generar URL",
    en: "Generate URL",
  },
  sendToSign: {
    es: "Enviar firma",
    en: "Send to sign",
  },
  sendToSign__confirm: {
    es: "¿Desea enviar este documento a firmar?",
    en: "Do you want to send this document for signing?",
  },
  sendToSign__success: {
    es: "Documento enviado a firmar con éxito",
    en: "Document sent for signing successfully",
  },
  sendToSign__error: {
    es: "Error al enviar el documento a firmar",
    en: "Error sending document for signing",
  },
  dateSent: {
    es: "Fecha de Envío",
    en: "Date Sent",
  },
  dateSigned: {
    es: "Fecha de Firma",
    en: "Date Signed",
  },
  generateCode: {
    es: "Generar Código",
    en: "Generate Code",
  },
  generateCode__confirm: {
    es: "¿Estás seguro de que deseas generar un nuevo código para este cupón?",
    en: "Are you sure you want to generate a new code for this coupon?",
  },
  generateCode__success: {
    es: "Código generado con éxito",
    en: "Code successfully generated",
  },
  generateCode__error: {
    es: "Error al generar código",
    en: "Error generating code",
  },
  vendor: {
    es: "Vendor",
    en: "Vendor",
  },
  salesRep: {
    es: "Gifter",
    en: "Gifter",
  },
  editGuest: {
    es: "Editar Invitado",
    en: "Edit Guest",
  },
  areaCode: {
    es: "Lada",
    en: "Area Code",
  },
  notes: {
    es: "Notas",
    en: "Notes",
  },
  notesPlaceholder: {
    es: "Ej. Venta",
    en: "Ex. Sale",
  },
  program: {
    es: "Programa",
    en: "Program",
  },
  selectProgram: {
    es: "Seleccione un programa",
    en: "Select a program",
  },
  selectSeller: {
    es: "Gifter",
    en: "Gifter",
  },
  noSellersAvailable: {
    es: "Sin vendedores disponibles para este programa",
    en: "No sellers available for this program",
  },
  coupons: {
    es: "Cupones",
    en: "Coupons",
  },
  coupon: {
    es: "Cupón",
    en: "Coupon",
  },
  selectCoupon: {
    es: "Seleccionar cupón",
    en: "Select coupon",
  },
  couponsOfGuest: {
    es: "Cupones de",
    en: "Coupons of",
  },
  meetingDateTime: {
    es: "Fecha y Hora de Reunión",
    en: "Meeting Date & Time",
  },
  selectDateRange: {
    es: "Selecciona un rango de fechas",
    en: "Select a date range",
  },
  noCouponsForGuest: {
    es: "No hay cupones para este invitado",
    en: "No coupons for this guest",
  },
  errorLoadingGuests: {
    es: "Error al consultar invitados",
    en: "Error loading guests",
  },
  selectProgramError: {
    es: "Debe seleccionar un programa",
    en: "You must select a program",
  },
  selectSellerError: {
    es: "Debe seleccionar un vendedor",
    en: "You must select a seller",
  },
  guestUpdated: {
    es: "Invitado actualizado",
    en: "Guest updated",
  },
  guestCreated: {
    es: "Invitado creado con éxito",
    en: "Guest created successfully",
  },
  errorSavingGuest: {
    es: "Error al guardar invitado",
    en: "Error saving guest",
  },
  registerCode: {
    es: "Registrar Código",
    en: "Register Code",
  },
  selectCouponError: {
    es: "Debe seleccionar un cupón",
    en: "You must select a coupon",
  },
  codeRegisteredSuccess: {
    es: "Código registrado con éxito",
    en: "Code registered successfully",
  },
  errorRegisteringCode: {
    es: "Error al registrar código",
    en: "Error registering code",
  },
  errorLoadingCoupons: {
    es: "Error al cargar lista de cupones",
    en: "Error loading coupon list",
  },
  viewCoupons: {
    es: "Ver Cupones",
    en: "View Coupons",
  },
  noMeetingAssigned: {
    es: "No tiene reunión asignada",
    en: "No meeting assigned",
  },
  registerCodeTooltip: {
    es: "Registrar Código",
    en: "Register Code",
  },
  completeRegistration: {
    es: "Completar Registro",
    en: "Complete Registration",
  },
  guestId: {
    es: "ID Invitado",
    en: "Guest ID",
  },
  manifest: {
    es: "Manifiesto",
    en: "Manifest",
  },
  viewDetail: {
    es: "Ver Detalle",
    en: "View Detail",
  },
  guestDetail: {
    es: "Detalle del Invitado",
    en: "Guest Detail",
  },
  generalInformation: {
    es: "Información General",
    en: "General Information",
  },
  giftsIssued: {
    es: "Regalos Emitidos",
    en: "Issued Gifts",
  },
  giftId: {
    es: "ID Regalo",
    en: "Gift ID",
  },
  manifestInformation: {
    es: "Información del Manifiesto",
    en: "Manifest Information",
  },
  // Leads que llegan por el webhook de Sales Systems Pros (Origen "Marketing SSP")
  sspLead: {
    es: {
      origin: "Origen",
      allOrigins: "Todos",
      inHouse: "In house",
      marketingSsp: "Marketing SSP",
      needsReview: "Requiere revisión",
      reviewTitle: "Revisión",
      reviewShort: {
        horario_no_encontrado: "Sin sesión",
        cupo_excedido: "Cupo excedido",
        email_duplicado: "Email duplicado",
      },
      reviewDetail: {
        horario_no_encontrado: "La hora que agendó SSP no coincide con ninguna sesión. Hay que reagendarla en GoHighLevel.",
        cupo_excedido: "Se registró en una sesión que ya estaba llena.",
        email_duplicado: "Hay otro guest con el mismo email.",
      },
      appointmentInSsp: "Estado de la cita en Sales Systems Pros",
      appointmentStatus: {
        confirmed: "Confirmada",
        cancelled: "Cancelada",
        noshow: "No-show",
      },
      events: {
        new_lead: "Agendado",
        lead_qualified: "Calificado",
        appointment_rescheduled: "Reagendado",
        appointment_cancelled: "Cancelado",
        no_show: "No-show",
      },
      qualificationTitle: "Calificación SSP",
      appointmentTitle: "Cita SSP",
      allFieldsTitle: "Todos los campos recibidos",
      field: "Campo",
      value: "Valor",
      noFields: "No se recibieron campos",
      fields: {
        LeadChannel: "Canal",
        VendorSource: "Vendor source",
        QnqStatus: "Q/NQ",
        LeadQualityScore: "Score",
        LeadQualityRating: "Rating",
        HouseholdIncome: "Ingreso del hogar",
        AgeRange: "Rango de edad",
        CitizenshipResidency: "Ciudadanía / residencia",
        PresentationAttendanceRequirements: "Requisitos de asistencia",
        TripsPerYear: "Viajes por año",
        OtaBookingHistory: "Historial en OTAs",
        OtaSpendLast12Months: "Gasto en OTAs (12 meses)",
        ComfortableTripBudget: "Presupuesto de viaje",
        MembershipPurchaseLikelihood: "Probabilidad de compra",
        RelationshipStatus: "Relación",
        SpouseFullName: "Pareja",
        DreamDestination: "Destino soñado",
        DreamTripBarrier: "Barrera para viajar",
        TravelCompanion: "Viaja con",
        ContactSource: "Formulario de origen",
        Tags: "Tags",
        UsuarioAsignado: "Usuario asignado (GHL)",
      },
      appointment: {
        status: "Estado",
        datetime: "Fecha y hora",
        cancunTime: "hora de Cancún",
        session: "Sesión asignada",
        noSession: "Sin sesión",
        link: "Enlace",
        calendar: "Calendario",
        history: "Historial",
        event: "Evento",
        appointmentDate: "Fecha de la cita",
        receivedAt: "Recibido",
        noHistory: "Sin eventos",
      },
      editInGhl: "Los leads de SSP se editan en GoHighLevel",
    },
    en: {
      origin: "Origin",
      allOrigins: "All",
      inHouse: "In house",
      marketingSsp: "Marketing SSP",
      needsReview: "Needs review",
      reviewTitle: "Review",
      reviewShort: {
        horario_no_encontrado: "No session",
        cupo_excedido: "Session over capacity",
        email_duplicado: "Duplicate email",
      },
      reviewDetail: {
        horario_no_encontrado: "The time SSP booked doesn't match any session. It must be rescheduled in GoHighLevel.",
        cupo_excedido: "It was registered in a session that was already full.",
        email_duplicado: "Another guest has the same email.",
      },
      appointmentInSsp: "Appointment status in Sales Systems Pros",
      appointmentStatus: {
        confirmed: "Confirmed",
        cancelled: "Cancelled",
        noshow: "No-show",
      },
      events: {
        new_lead: "Booked",
        lead_qualified: "Qualified",
        appointment_rescheduled: "Rescheduled",
        appointment_cancelled: "Cancelled",
        no_show: "No-show",
      },
      qualificationTitle: "SSP Qualification",
      appointmentTitle: "SSP Appointment",
      allFieldsTitle: "All fields received",
      field: "Field",
      value: "Value",
      noFields: "No fields received",
      fields: {
        LeadChannel: "Channel",
        VendorSource: "Vendor source",
        QnqStatus: "Q/NQ",
        LeadQualityScore: "Score",
        LeadQualityRating: "Rating",
        HouseholdIncome: "Household income",
        AgeRange: "Age range",
        CitizenshipResidency: "Citizenship / residency",
        PresentationAttendanceRequirements: "Attendance requirements",
        TripsPerYear: "Trips per year",
        OtaBookingHistory: "OTA booking history",
        OtaSpendLast12Months: "OTA spend (12 months)",
        ComfortableTripBudget: "Trip budget",
        MembershipPurchaseLikelihood: "Purchase likelihood",
        RelationshipStatus: "Relationship",
        SpouseFullName: "Partner",
        DreamDestination: "Dream destination",
        DreamTripBarrier: "Dream trip barrier",
        TravelCompanion: "Travels with",
        ContactSource: "Source form",
        Tags: "Tags",
        UsuarioAsignado: "Assigned user (GHL)",
      },
      appointment: {
        status: "Status",
        datetime: "Date and time",
        cancunTime: "Cancun time",
        session: "Assigned session",
        noSession: "No session",
        link: "Link",
        calendar: "Calendar",
        history: "History",
        event: "Event",
        appointmentDate: "Appointment date",
        receivedAt: "Received",
        noHistory: "No events",
      },
      editInGhl: "SSP leads are edited in GoHighLevel",
    },
  },
  manifestSaved: {
    es: "Manifiesto guardado con éxito",
    en: "Manifest saved successfully",
  },
  errorSavingManifest: {
    es: "Error al guardar el manifiesto",
    en: "Error saving the manifest",
  },
  rating: {
    es: "Rating",
    en: "Rating",
  },
  ratingNoShow: {
    es: "No Show",
    en: "No Show",
  },
  ratingWalkout: {
    es: "Walkout",
    en: "Walkout",
  },
  ratingShowFail: {
    es: "Show/Fail",
    en: "Show/Fail",
  },
  ratingShowWin: {
    es: "Show/Win",
    en: "Show/Win",
  },
  giftType: {
    es: "Tipo de Regalo",
    en: "Gift Type",
  },
  giftTypeWeeks: {
    es: "Semanas",
    en: "Weeks",
  },
  giftTypeCruise: {
    es: "Crucero",
    en: "Cruise",
  },
  noGift: {
    es: "Sin regalo",
    en: "No gift",
  },
  chooseGiftTypePlaceholder: {
    es: "Elige…",
    en: "Choose…",
  },
  chooseGiftTypeRequired: {
    es: "En una venta elige el Gift Type: «Weeks» si lleva regalo o «Sin regalo» si no.",
    en: "For a sale, choose the Gift Type: «Weeks» if it includes a gift or «No gift» if not.",
  },
  secondGiftBlocked: {
    es: "Este guest ya recibió {anterior}. Con este cambio recibiría un segundo correo con el mismo código, que no se puede retirar. Pídeselo a un administrador o a un VLO.",
    en: "This guest already received {anterior}. This change would send a second email with the same code, which can't be taken back. Ask an administrator or a VLO.",
  },
  secondGiftTitle: {
    es: "Segundo regalo para el mismo guest",
    en: "Second gift for the same guest",
  },
  secondGiftText: {
    es: "{email} ya recibió {anterior}. Si guardas, también recibirá {regalo} <b>con el mismo código</b>. Ninguno de los dos se puede retirar. ¿Enviar el segundo?",
    en: "{email} already received {anterior}. If you save, they will also receive {regalo} <b>with the same code</b>. Neither can be taken back. Send the second one?",
  },
  secondGiftOk: {
    es: "Sí, enviar el segundo",
    en: "Yes, send the second one",
  },
  markAsLost: {
    es: "Cerrado perdido",
    en: "Closed lost",
  },
  markAsLostNotice: {
    es: "El invitado ya no va a comprar. Su tarjeta en HubSpot pasa a Closed Lost; al desmarcarlo regresa a la etapa del Rating.",
    en: "The guest is not going to buy. Their HubSpot card moves to Closed Lost; unchecking it returns it to the Rating's stage.",
  },
  lostReason: {
    es: "Motivo de la pérdida",
    en: "Reason it was lost",
  },
  lostReasonPlaceholder: {
    es: "Ej.: no le alcanza el presupuesto, ya compró en otro lado, no contesta...",
    en: "E.g.: can't afford it, already bought elsewhere, doesn't answer...",
  },
  giftConfirmTitle: {
    es: "Se enviará un regalo al invitado",
    en: "A gift will be sent to the guest",
  },
  giftConfirmText: {
    es: "Al guardar, la tarjeta pasa a {etapa} y HubSpot le enviará {regalo} a {email}. Ya no se puede retirar. ¿Continuar?",
    en: "When you save, the card moves to {etapa} and HubSpot will send {regalo} to {email}. It can't be taken back. Continue?",
  },
  giftConfirmOk: {
    es: "Guardar y enviar",
    en: "Save and send",
  },
  giftConfirmCancel: {
    es: "Revisar",
    en: "Review",
  },
  giftNames: {
    es: {
      noCompletada: 'el certificado "no completada"',
      completada: "el certificado Preferred Traveler Access",
      sinRegalo: "el correo de agradecimiento (sin certificado)",
    },
    en: {
      noCompletada: 'the "not completed" certificate',
      completada: "the Preferred Traveler Access certificate",
      sinRegalo: "the thank-you email (no certificate)",
    },
  },
  lostReasonRequired: {
    es: "Escribe el motivo de la pérdida para marcarlo como perdido.",
    en: "Enter the reason it was lost to mark it as lost.",
  },
  classification: {
    es: "Clasificación",
    en: "Classification",
  },
  saleLabel: {
    es: "Venta",
    en: "Sale",
  },
  vendorFromGuestNotice: {
    es: "Se toma del invitado; se cambia al editarlo.",
    en: "Taken from the guest; change it by editing the guest.",
  },
  saleAutoNotice: {
    es: "Se determina automáticamente según si el invitado ya tiene un contrato.",
    en: "Determined automatically by whether the guest already has a contract.",
  },
  greeter: {
    es: "Greeter",
    en: "Greeter",
  },
  gifter: {
    es: "Gifter",
    en: "Gifter",
  },
  tech: {
    es: "Tech",
    en: "Tech",
  },
  podium: {
    es: "Podium",
    en: "Podium",
  },
  closer: {
    es: "Closer",
    en: "Closer",
  },
  saleDirector: {
    es: "Sale Director",
    en: "Sale Director",
  },
  searchUser: {
    es: "Buscar usuario",
    en: "Search user",
  },
  noUsersFound: {
    es: "No se encontraron usuarios",
    en: "No users found",
  },
  notAssigned: {
    es: "Sin asignar",
    en: "Not assigned",
  },
  sendPaymentLink: {
    es: "Enviar enlace de pago",
    en: "Send payment link",
  },
  processing: {
    es: "Procesando...",
    en: "Processing...",
  },
  selectPlan: {
    es: "Seleccionar Plan",
    en: "Select Plan",
  },
  paymentOption: {
    es: "Opción de Pago",
    en: "Payment Option",
  },
  customAmount: {
    es: "Monto Personalizado",
    en: "Custom Amount",
  },
  installments: {
    es: "Mensualidades",
    en: "Installments",
  },
  originalPrice: {
    es: "Precio Original",
    en: "Original Price",
  },
  discount10: {
    es: "Descuento (10%)",
    en: "Discount (10%)",
  },
  totalToPay: {
    es: "Total a Pagar",
    en: "Total to Pay",
  },
  downPayment: {
    es: "Pago Inicial",
    en: "Down Payment",
  },
  financedAmount: {
    es: "Monto Financiado",
    en: "Financed Amount",
  },
  monthlyPayment: {
    es: "Pago Mensual",
    en: "Monthly Payment",
  },
  months: {
    es: "meses",
    en: "months",
  },
  cancel: {
    es: "Cancelar",
    en: "Cancel",
  },
  generateAndSendLink: {
    es: "Generar y Enviar Enlace",
    en: "Generate & Send Link",
  },
  fullPayment: {
    es: "Pago de Contado",
    en: "Full Payment",
  },
  fullPaymentDiscount: {
    es: "Pago de Contado (10% Descuento)",
    en: "Full Payment (10% Discount)",
  },
  down50: {
    es: "50% de Enganche",
    en: "50% Down",
  },
  down30: {
    es: "30% de Enganche",
    en: "30% Down",
  },
  paymentLinkSentEmail: {
    es: "Enlace de pago enviado correctamente por correo.",
    en: "Payment link sent successfully via email.",
  },
  errorGeneratingLink: {
    es: "Error al generar enlace de pago",
    en: "Error generating payment link",
  },
  monthlyInterest: {
    es: "mensual",
    en: "monthly",
  },
  stage: {
    es: "Estado",
    en: "Stage",
  },
  selectStage: {
    es: "Seleccionar estado",
    en: "Select stage",
  },
  hubspotStage: {
    es: "Estado HubSpot",
    en: "HubSpot Stage",
  },
  hubspotStagesTranslation: {
    // Claves = stageName exacto del pipeline "Online Sales – MVP", en orden de HubSpot.
    // Las últimas dos claves de cada idioma son nombres viejos que HubSpot ya renombró;
    // se dejan como respaldo para prospectos que no alcanzó a corregir el backfill.
    es: {
      "New Lead": "Nuevo Lead",
      "Contacted": "Contactado",
      "Presentation Scheduled": "Presentación Programada",
      "Presentation No-Show / Missed": "Presentación No Asistida / Perdida",
      "Show Complete No Sale": "Presentación Completa Sin Venta",
      "Show No Compl/Walkout": "Presentación Incompleta / Abandono",
      "Sale & Gift": "Venta con Regalo",
      "Sale No Gift": "Venta sin Regalo",
      "Contract Sent": "Contrato Enviado",
      "Contract Signed": "Contrato Firmado",
      "Payment Completed – Closed Won": "Pago Completado – Cerrado Ganado",
      "Closed Lost": "Cerrado Perdido",
      "Presentation Attended": "Presentación Asistida",
      "Payment Completed": "Pago Completado",
    },
    en: {
      "New Lead": "New Lead",
      "Contacted": "Contacted",
      "Presentation Scheduled": "Presentation Scheduled",
      "Presentation No-Show / Missed": "Presentation No-Show / Missed",
      "Show Complete No Sale": "Show Complete No Sale",
      "Show No Compl/Walkout": "Show No Compl/Walkout",
      "Sale & Gift": "Sale & Gift",
      "Sale No Gift": "Sale No Gift",
      "Contract Sent": "Contract Sent",
      "Contract Signed": "Contract Signed",
      "Payment Completed – Closed Won": "Payment Completed – Closed Won",
      "Closed Lost": "Closed Lost",
      "Presentation Attended": "Presentation Attended",
      "Payment Completed": "Payment Completed",
    }
  },
  reserveDetailsFields: {
    es: {
      ResortId: "ID del Resort",
      ResortID: "ID del Resort",
      InventoryID: "ID de Inventario",
      ResortName: "Nombre del Resort",
      ResortCity: "Ciudad",
      ResortState: "Estado / Provincia",
      ResortCountry: "País",
      ResortRegion: "Región",
      ResortPhone: "Teléfono",
      ResortAddress1: "Dirección",
      ResortAddress2: "Dirección 2",
      ResortAddress3: "Dirección 3",
      ResortAddress4: "Dirección 4",
      ResortZip: "Código Postal",
      CheckInDate: "Fecha de Check-In",
      CheckOutDate: "Fecha de Check-Out",
      Nights: "Noches",
      UnitType: "Tipo de Unidad",
      nbrOfBathrooms: "Baños",
      KitchenType: "Cocina",
      MaxOccupancy: "Ocupación Máxima",
      PrivacyOccupancy: "Ocupación Privacidad",
      AllInclusive: "Todo Incluido",
      UnitCount: "Unidades Disponibles",
      Price: "Precio",
      Cost: "Costo",
      InvType: "Tipo de Inventario",
      InvTypeInDetail: "Tipo de Semana",
      Rating: "Calificación",
      FechaCreacion: "Fecha de Creación",
      ImportantNotesSP: "Notas Importantes (ES)",
      ImportantNotesEN: "Notas Importantes (EN)",
      HighlightsSP: "Destacados del Resort (ES)",
      HighlightsEN: "Destacados del Resort (EN)",
      ResortHighLights: "Destacados del Resort",
      Amenities: "Amenidades",
      GPS_Lat: "Latitud",
      GPS_Long: "Longitud",
      ImagePath: "Ruta de Imagen",
      Images: "Imágenes",
      imgs: "Imágenes",
      InsertImages: "Imágenes Insertadas",
      ListofAssets: "Lista de Activos",
      status: "Estado",
      createdAt: "Fecha de Creación",
      updatedAt: "Última Actualización",
      createdAtMs: "Fecha de Creación",
    },
    en: {
      ResortId: "Resort ID",
      ResortID: "Resort ID",
      InventoryID: "Inventory ID",
      ResortName: "Resort Name",
      ResortCity: "City",
      ResortState: "State / Province",
      ResortCountry: "Country",
      ResortRegion: "Region",
      ResortPhone: "Phone",
      ResortAddress1: "Address",
      ResortAddress2: "Address 2",
      ResortAddress3: "Address 3",
      ResortAddress4: "Address 4",
      ResortZip: "Zip Code",
      CheckInDate: "Check-In Date",
      CheckOutDate: "Check-Out Date",
      Nights: "Nights",
      UnitType: "Unit Type",
      nbrOfBathrooms: "Bathrooms",
      KitchenType: "Kitchen",
      MaxOccupancy: "Max. Occupancy",
      PrivacyOccupancy: "Privacy Occupancy",
      AllInclusive: "All Inclusive",
      UnitCount: "Available Units",
      Price: "Price",
      Cost: "Cost",
      InvType: "Inventory Type",
      InvTypeInDetail: "Week Type",
      Rating: "Rating",
      FechaCreacion: "Created At",
      ImportantNotesSP: "Important Notes (ES)",
      ImportantNotesEN: "Important Notes (EN)",
      HighlightsSP: "Resort Highlights (ES)",
      HighlightsEN: "Resort Highlights (EN)",
      ResortHighLights: "Resort Highlights",
      Amenities: "Amenities",
      GPS_Lat: "Latitude",
      GPS_Long: "Longitude",
      ImagePath: "Image Path",
      Images: "Images",
      imgs: "Images",
      InsertImages: "Inserted Images",
      ListofAssets: "Asset List",
      status: "Status",
      createdAt: "Created At",
      updatedAt: "Last Updated",
      createdAtMs: "Created At",
    },
  },
  reserveDetailsSummary: {
    es: {
      title: "Detalles de la Semana",
      subtitle: "Resumen de la semana seleccionada",
      stay: "Estadía",
      unit: "Unidad",
      location: "Ubicación",
      notes: "Notas y Destacados",
      amenities: "Amenidades",
      noData: "No hay información disponible para mostrar",
      noImages: "Sin imágenes disponibles",
      checkIn: "Check-In",
      checkOut: "Check-Out",
      resort: "Resort",
      reference: "Referencia",
      openMap: "Ver en Google Maps",
      distance: "Distancia",
      proximityOnsite: "En el resort",
      proximityNearby: "Cercano",
      proximityOffsite: "Fuera del sitio",
    },
    en: {
      title: "Week Details",
      subtitle: "Summary of the selected week",
      stay: "Stay",
      unit: "Unit",
      location: "Location",
      notes: "Notes & Highlights",
      amenities: "Amenities",
      noData: "No information available to display",
      noImages: "No images available",
      checkIn: "Check-In",
      checkOut: "Check-Out",
      resort: "Resort",
      reference: "Reference",
      openMap: "Open in Google Maps",
      distance: "Distance",
      proximityOnsite: "Onsite",
      proximityNearby: "Nearby",
      proximityOffsite: "Offsite",
    },
  }
};
